<!-- eslint-disable max-len, vue/valid-v-model -->
<template>
  <div
    id="vp-action"
    :class="{
      'object-container-automation' : !onProperties,
      'object-active' : blockActive || (!onProperties && id === propertiesIDBlock),
      'object-disabled' : !onProperties && isDisableBlock
    }"
    class="position-relative"
    style="cursor:default"
    @mouseover="pauseZoom"
    @mouseleave="resumeZoom"
  >
    <!-- Disable Block -->
    <div
      v-if="onProperties"
      :style="[!data_action.object ? { 'top': '-33px' } : '' ]"
      class="toggle-disable-block"
    >
      <j-switch v-model="disable_block" />

      <!-- Tooltip -->
      <div class="tooltip-toggle-disable">
        {{ disable_block ? 'Disable' : 'Enable' }} this block
      </div>
    </div>

    <template v-if="!onProperties">
      <img
        src="@/assets/new-form-ui/dragged.svg"
        class="icon-drag"
      >
      <img
        :src="require('@/assets/automation/action-lg.png')"
        width="22"
        class="m__r--5">
      <span class="title-automation m__r--5">ACTION</span>
      <span class="id-block-automation">{{ dataEdit ? `#${dataEdit.id}` : '' }}</span>
    </template>
    <img
      v-if="!onProperties"
      :src="require('@/assets/automation/config.svg')"
      width="20"
      height="20"
      class="pull-right cursor-pointer"
      @click="showProperties">
    <img
      v-if="!onProperties && dataEdit && (objectType === 'function' || objectType === 'job' || objectType === 'dedicated_job')"
      :src="require('@/assets/automation/open-tab.svg')"
      width="20"
      height="20"
      class="pull-right cursor-pointer m__r--5"
      @click="openTabVP">

    <div v-show="onProperties">
      <b-form-group
        v-if="!data_action.object"
        :class="{'error-input' : $v.data_action.object.$error}">
        <label> Object </label>
        <j-single-select
          v-model="$v.data_action.object.$model"
          :error-required="$v.data_action.object.$error"
          :options="objectOptionsFiltered"
          placeholder="Object"
          @getData="objectSelected"/>
      </b-form-group>
      <div
        v-else
        class="sub-header-properties-wrap">
        <img
          :src="require(`@/assets/automation/${selectedObject.img}.svg`)"
          width="25">
        <div class="text-object"> {{ selectedObject.title }} </div>
      </div>

      <div v-if="data_action.object === 'form'">
        <b-row>
          <b-col md="12">
            <b-form-group :class="{'error-input' : $v.data_action.table_group.$error}">
              <label> Table Group </label>
              <j-single-select
                v-model="$v.data_action.table_group.$model"
                :error-required="$v.data_action.table_group.$error"
                :options="tableGroupOptions"
                placeholder="Select Table Group"
                value-format="object"
                label="name"/>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group :class="{'error-input' : $v.data_action.form.$error}">
              <label> Table </label>
              <j-single-select
                v-model="$v.data_action.form.$model"
                :error-required="$v.data_action.form.$error"
                :disabled="!data_action.table_group"
                :options="tableOptions"
                :placeholder="'Select Table'"
                value-format="object"
                label="name"/>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group :class="{'error-input' : $v.data_action.do.$error}">
              <label> Do </label>
              <j-single-select
                v-model="$v.data_action.do.$model"
                :error-required="$v.data_action.do.$error"
                :options="doOptions"
                placeholder="Do"/>
            </b-form-group>
          </b-col>
        </b-row>

        <div v-if="data_action.do === 'find_record' || data_action.do === 'find_records' || data_action.do === 'update_record'">
          <hr>
          <div class="d-flex justify-content-between">
            <div>
              <span class="title-automation">Conditions</span>
              <small>"Where"</small>
            </div>
            <div class="d-flex">
              <div
                :class="{ 'active': versionFilter === 'v1' }"
                class="swithcer-filter m__r--8"
                @click="versionFilter = 'v1'"
              >
                V1
              </div>
              <div
                :class="{ 'active': versionFilter === 'v2' }"
                class="swithcer-filter"
                @click="versionFilter = 'v2'"
              >
                V2
              </div>
            </div>
          </div>

          <div
            v-if="versionFilter === 'v2'"
            :class="{'error-input': $v.data_action.conditions.$error}"
            class="conditions-wrap">
            <div
              :class="{'show-vertical-line': data_action.conditions &&
                         data_action.conditions.length > 1,
                       'hide-vertical-line': data_action.conditions && data_action.conditions.length === 1 }"
              class="conditions-left">
              <div
                v-if="data_action.conditions && data_action.conditions.length > 1"
                class="conditions-vertical-line">
                <div/>
                <div class="v-line-top v-line" />
                <div/>
              </div>
              <div class="conditions-operator">AND</div>
              <div
                v-if="data_action.conditions && data_action.conditions.length > 1"
                class="conditions-vertical-line">
                <div/>
                <div class="v-line-bottom v-line" />
                <div/>
              </div>
            </div>
            <div class="conditions-right">
              <div
                v-if="data_action.conditions && data_action.conditions.length > 0"
                class="mb-2">
                <div
                  v-for="(item, index) in data_action.conditions"
                  :key="index"
                  :class="{'selected' : index === selectedIndexCondition}"
                  class="conditions-item-wrap">
                  <div class="field-item"> {{ item.field }} </div>
                  <div class="operator-item"> {{ item.operator ? item.operator.replaceAll('_', ' ') : '' }} </div>
                  <div
                    v-if="item.operator !== 'between'"
                    class="value-item">
                    <span> {{ item.value }} </span>
                  </div>
                  <div
                    v-else
                    class="value-item">
                    {{ item.value[0] }}
                    <i class="fa fa-arrow-right mx-3"/>
                    {{ item.value[1] }}
                  </div>

                  <!-- Edit or Delete -->
                  <div class="edit-or-delete">
                    <div class="button">
                      <!-- Edit -->
                      <div
                        class="edit d-flex"
                        @click="openModalCondition(index)">
                        <i class="fa fa-pencil-square-o" />
                      </div>
                      <!-- Delete -->
                      <div
                        class="delete"
                        @click="deleteConditions(index)">
                        <i class="fa fa-trash" />
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div
                class="add-conditions"
                @click="openModalCondition()">+ Add Filter
              </div>
            </div>
          </div>
          <div v-else>
            <b-row
              v-for="(item, index) in $v.data_action.conditions.$each.$iter"
              :key="index">
              <b-col
                md="5"
                class="p__r--3">
                <b-form-group :class="{'error-input' : item.field.$error}">
                  <label> Field </label>
                  <j-single-select
                    v-model="item.field.$model"
                    :error-required="item.field.$error"
                    :options="list_field"
                    label="name"
                    placeholder="Field"/>
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                class="p__r--3 p__l--3">
                <b-form-group :class="{'error-input' : item.operator.$error}">
                  <label> Operator </label>
                  <j-input
                    :error-required="false"
                    :disabled="true"
                    value="Is"/>
                </b-form-group>
              </b-col>
              <b-col
                md="4"
                class="p__r--3 p__l--3">
                <b-form-group :class="{'error-input' : item.value.$error}">
                  <label> Value </label>
                  <j-input
                    v-model="item.value.$model"
                    :error-required="item.value.$error"
                    :max-length="255"
                    placeholder="Value"/>
                </b-form-group>
              </b-col>
              <b-col
                md="1"
                class="cursor-pointer p__l--5">
                <i
                  class="fa fa-lg fa-trash m__t--35"
                  @click="deleteConditions(index)"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <button
                  class="btn float-right btn-add-additional-info"
                  @click="addConditions">
                  + Add Conditions
                </button>
              </b-col>
            </b-row>
          </div>
        </div>

        <div v-if="data_action.do === 'delete_record'">
          <hr>
          <span class="title-automation">Conditions</span>
          <small>"Where"</small>
          <b-row
            v-for="(item, index) in $v.data_action.conditions.$each.$iter"
            :key="index">
            <b-col
              md="5"
              class="p__r--3">
              <b-form-group :class="{'error-input' : item.field.$error}">
                <label> Field </label>
                <j-single-select
                  v-model="item.field.$model"
                  :error-required="item.field.$error"
                  :options="list_field"
                  label="name"
                  placeholder="Field"/>
              </b-form-group>
            </b-col>
            <b-col
              md="2"
              class="p__r--3 p__l--3">
              <b-form-group :class="{'error-input' : item.operator.$error}">
                <label> Operator </label>
                <j-single-select
                  v-model="item.operator.$model"
                  :error-required="item.operator.$error"
                  :options="operatorOptions"/>
              </b-form-group>
            </b-col>
            <b-col
              md="4"
              class="p__r--3 p__l--3">
              <b-form-group :class="{'error-input' : item.value.$error}">
                <label> Value </label>
                <j-input
                  v-model="item.value.$model"
                  :error-required="item.value.$error"
                  :max-length="255"
                  placeholder="Value"/>
              </b-form-group>
            </b-col>
            <b-col
              md="1"
              class="cursor-pointer p__l--5">
              <i
                class="fa fa-lg fa-trash m__t--35"
                @click="deleteConditions(index)"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <button
                class="btn float-right btn-add-additional-info"
                @click="addConditions">
                + Add Conditions
              </button>
            </b-col>
          </b-row>
        </div>

        <div
          v-if="data_action.do === 'find_records'"
          class="mt-2">
          <b-row>
            <b-col md="6">
              <b-form :class="{'error-input' : $v.data_action.sorting.key.$error}">
                <label> Sort By </label>
                <j-single-select
                  v-model="data_action.sorting.key"
                  :error-required="$v.data_action.sorting.key.$error"
                  :options="list_field"
                  :placeholder="'Sort by'"
                  value-format="object"
                  label="name"/>
              </b-form>
            </b-col>
            <b-col md="6">
              <b-form :class="{'error-input' : $v.data_action.sorting.order.$error}">
                <label> Order By </label>
                <j-single-select
                  v-model="data_action.sorting.order"
                  :error-required="$v.data_action.sorting.order.$error"
                  :options="orderOptions"
                  :placeholder="'Order by'"
                  value-format="object"
                  label="label"/>
              </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-form-group :class="{'error-input' : $v.data_action.page.$error}">
                <label> Page </label>
                <j-input
                  v-model="data_action.page"
                  :error-required="$v.data_action.page.$error"
                  placeholder="Page"/>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group :class="{'error-input' : $v.data_action.limit.$error}">
                <label> Limit </label>
                <j-input
                  v-model="data_action.limit"
                  :error-required="$v.data_action.limit.$error"
                  placeholder="Limit"/>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <div v-if="data_action.do === 'create_record' || data_action.do === 'update_record'">
          <hr>
          <span class="title-automation">List Fields</span>
          <j-form-record
            v-if="showBase"
            ref="jFormCreate"
            :data-fields="dataFields"
            :is-detail="dataEdit ? true : false"/>
        </div>

        <div v-if="data_action.do === 'create_records'">
          <hr>
          <span class="title-automation">Data Input</span>
          <b-form-group :class="{'error-input' : $v.data_action.input.$error}">
            <b-row>
              <b-col md="8">
                <label> Body </label>
              </b-col>
              <b-col md="4">
                <small
                  class="title-example-input-joana-create-records"
                  @click="toggleModalExample(true)">Example</small>
              </b-col>
            </b-row>
            <prism-editor
              v-model="$v.data_action.input.$model"
              :highlight="highlighter"
              :line-numbers="true"
              :class="{'dark-mode' : darkMode}"
              class="my-editor-block-joana"
            />
          </b-form-group>
        </div>
      </div>

      <div v-if="data_action.object === 'call_webhook'">
        <span class="title-automation">Endpoint</span>
        <b-row>
          <b-col md="4">
            <b-form-group :class="{'error-input' : $v.data_action.method.$error}">
              <label> Method </label>
              <j-single-select
                v-model="$v.data_action.method.$model"
                :error-required="$v.data_action.method.$error"
                :options="methodOptions"
                placeholder="Select"/>
            </b-form-group>
          </b-col>
          <b-col md="8">
            <b-form-group :class="{'error-input' : $v.data_action.url.$error}">
              <label> Url </label>
              <j-input
                v-model="$v.data_action.url.$model"
                :max-length="255"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title-automation">Header</span>
          </b-col>
          <b-col cols="12">
            <div
              v-for="(data, index) in data_action.column"
              :key="index + 0"
              class="list-column-ui">
              <b-row>
                <div
                  class="d-flex align-items-center justify-content-center cursor-pointer m__l--16">
                  <i class="fa fa-lg fa-ellipsis-v "/>
                </div>
                <b-col cols="5">
                  <b-form-group>
                    <label> Name </label>
                    <j-input
                      v-model="data.name"
                      placeholder="Enter column name"/>
                  </b-form-group>
                </b-col>
                <b-col cols="5">
                  <b-form-group>
                    <label> Value </label>
                    <j-input
                      v-model="data.value"
                      placeholder="Enter column value"/>
                  </b-form-group>
                </b-col>
                <div
                  class="d-flex align-items-center justify-content-center cursor-pointer m__l--1">
                  <i
                    class="fa fa-lg fa-trash"
                    @click="deleteColumn(index)"/>
                </div>
              </b-row>
            </div>
            <b-row>
              <b-col cols="12">
                <button
                  class="btn btn-add-column"
                  @click="addColumn">
                  + Add Header
                </button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <div v-if="data_action.method === 'post' || data_action.method === 'delete'">
          <span class="title-automation">Payload</span>
          <b-form-group :class="{'error-input' : $v.data_action.body.$error}">
            <b-row>
              <b-col md="8">
                <label> Body </label>
              </b-col>
              <b-col
                md="3"
                class="p__r--1">
                <small class="pull-right">Dark Mode</small>
              </b-col>
              <b-col
                md="1"
                class="p__l--1">
                <j-toggle v-model="darkMode"/>
              </b-col>
            </b-row>
            <prism-editor
              v-model="$v.data_action.body.$model"
              :highlight="highlighter"
              :line-numbers="true"
              :class="{'dark-mode' : darkMode}"
              class="my-editor"
            />
          </b-form-group>
        </div>
      </div>

      <div v-if="data_action.object === 'send_notification'">
        <b-form-group :class="{'error-input' : $v.data_action.type.$error}">
          <label> Type </label>
          <j-single-select
            v-model="$v.data_action.type.$model"
            :error-required="$v.data_action.type.$error"
            :options="typeNotifOptions"
            placeholder="Type"/>
        </b-form-group>

        <b-form-group
          v-if="data_action.type === 'send_email'"
          :class="{'error-input' : $v.data_action.to_email.$error}">
          <label> To </label>
          <j-input
            v-model="$v.data_action.to_email.$model"
            :error-required="$v.data_action.to_email.$error"
            :placeholder="'To'"
            :max-length="255"
            label="name"/>
        </b-form-group>

        <b-form-group v-if="data_action.type === 'send_email'">
          <label> CC </label>
          <j-input
            v-model="data_action.cc"
            :placeholder="'CC'"
            :max-length="255"
            label="name"/>
        </b-form-group>

        <b-form-group v-if="data_action.type === 'send_email'">
          <label> BCC </label>
          <j-input
            v-model="data_action.bcc"
            :placeholder="'BCC'"
            :max-length="255"
            label="name"/>
        </b-form-group>

        <b-form-group
          v-if="data_action.type === 'send_notification'"
          :class="{'error-input' : $v.data_action.push_notif_to.$error}">
          <label> To </label>
          <j-input
            v-model="$v.data_action.push_notif_to.$model"
            :error-required="$v.data_action.push_notif_to.$error"
            :placeholder="'To'"
            value-format="object"
            label="name"/>
        </b-form-group>

        <b-form-group
          v-if="data_action.type === 'send_email'"
          :class="{'error-input' : $v.data_action.subject.$error}">
          <label> Subject </label>
          <j-input
            v-model="$v.data_action.subject.$model"
            :error-required="$v.data_action.subject.$error"
            :max-length="255"
            placeholder="Subject"/>
        </b-form-group>

        <b-form-group
          v-if="data_action.type === 'send_email'"
          :class="{'error-input' : $v.data_action.message.$error}">
          <label> Body </label>
          <quill-editor
            ref="myQuillEditor"
            v-model="$v.data_action.message.$model"
            :error-required="$v.data_action.message.$error"
            :options="editorOption"
          />
        </b-form-group>

        <b-form-group
          v-if="data_action.type === 'send_notification'"
          :class="{'error-input' : $v.data_action.push_notif_heading.$error}">
          <label> Heading </label>
          <j-input
            v-model="$v.data_action.push_notif_heading.$model"
            :error-required="$v.data_action.push_notif_heading.$error"
            :max-length="255"
            placeholder="Heading"/>
        </b-form-group>

        <b-form-group
          v-if="data_action.type === 'send_notification'"
          :class="{'error-input' : $v.data_action.push_notif_content.$error}">
          <label> Content </label>
          <j-textarea
            v-model="$v.data_action.push_notif_content.$model"
            :error-required="$v.data_action.push_notif_content.$error"
            :max-length="300"/>
        </b-form-group>

        <b-form-group v-if="data_action.type === 'send_notification'">
          <label> Custom Redirect </label>
          <j-toggle v-model="data_action.is_custom_redirect"/>
        </b-form-group>

        <b-form-group
          v-if="data_action.is_custom_redirect"
          :class="{'error-input' : $v.data_action.script_redirect.$error}">
          <label> Script Redirect </label>
          <j-monaco-editor
            ref="scriptEditor"
            :value="data_action.script_redirect"
          />
        </b-form-group>

        <b-form-group
          v-if="data_action.is_custom_redirect"
          :class="{'error-input' : $v.data_action.variable_redirect.$error}">
          <label> Variable Redirect </label>
          <j-input
            v-model="$v.data_action.variable_redirect.$model"
            :error-required="$v.data_action.variable_redirect.$error"
            :max-length="255"
            placeholder="Variable Redirect"/>
        </b-form-group>
      </div>

      <!-- <div v-if="data_action.object === 'read_file' || data_action.object === 'generate_spreadsheet_file'">
        <b-form-group :class="{'error-input' : $v.data_action.type.$error}">
          <label> Type </label>
          <j-single-select
            v-model="$v.data_action.type.$model"
            :error-required="$v.data_action.type.$error"
            :options="typeFileOptions"
            placeholder="Type"/>
        </b-form-group>

        <b-row v-if="data_action.object === 'generate_spreadsheet_file'">
          <b-col cols="12">
            <span class="title-automation">Column</span>
          </b-col>
          <b-col cols="12">
            <draggable v-model="$v.data_action.column.$model">
              <transition-group>
                <div
                  v-for="(data, index) in data_action.column"
                  :key="index + 0"
                  class="list-column-ui">
                  <b-row>
                    <div
                      class="d-flex align-items-center justify-content-center cursor-pointer m__l--16">
                      <i class="fa fa-2x fa-ellipsis-v "/>
                    </div>
                    <b-col cols="5">
                      <b-form-group :class="{'error-input' : data.name.$error}">
                        <label> Name </label>
                        <j-input
                          v-model="data.name.$model"
                          placeholder="Enter column name"/>
                      </b-form-group>
                    </b-col>
                    <b-col cols="5">
                      <b-form-group :class="{'error-input' : data.value.$error}">
                        <label> Value </label>
                        <j-input
                          v-model="data.value.$model"
                          placeholder="Enter column value"/>
                      </b-form-group>
                    </b-col>
                    <div
                      class="d-flex align-items-center justify-content-center cursor-pointer m__l--1">
                      <i
                        class="fa fa-2x fa-trash"
                        @click="deleteColumn(index)"/>
                    </div>
                  </b-row>
                </div>
              </transition-group>
            </draggable>
            <b-row>
              <b-col cols="12">
                <button
                  class="btn btn-add-column"
                  @click="addColumn">
                  + Add Header
                </button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>

      <div v-if="data_action.object === 'transform_file'">
        <b-form-group :class="{'error-input' : $v.data_action.type.$error}">
          <label> Type </label>
          <j-single-select
            v-model="$v.data_action.type.$model"
            :error-required="$v.data_action.type.$error"
            :options="typeTransformOptions"
            placeholder="Type"/>
        </b-form-group>

        <hr>
        <span class="title-automation">Container</span>
        <b-form-group :class="{'error-input' : $v.data_action.variable_name_container.$error}">
          <label> Variable Name </label>
          <j-input
            v-model="$v.data_action.variable_name_container.$model"
            :error-required="$v.data_action.variable_name_container.$error"
            :max-length="255"
            placeholder="Variable Name Container"/>
        </b-form-group>
      </div> -->

      <div v-if="data_action.object === 'data_connectivity'">
        <b-row>
          <b-col cols="6">
            <b-form-group :class="{'error-input' : $v.data_action.connection.$error}">
              <b-popover
                :show.sync="popOverJDCShow"
                :ref="`popoverJDCBlockRef-${dataIndex}`"
                :target="`popoverJDCBlock-${dataIndex}`"
                container="vp-action"
                triggers="hover focus"
                placement="bottom">

                <div class="popoverJDC">
                  {{ dataConnectionDescription }}
                </div>

              </b-popover>
              <label> Connection <i
                v-show="data_action.connection != null "
                :id="`popoverJDCBlock-${dataIndex}`"
                class="fa fa-info-circle"
                @click="popOverJDCHandler" />  </label>
              <j-single-select
                v-model="$v.data_action.connection.$model"
                :error-required="$v.data_action.connection.$error"
                :options="loadOptionsDataConnectivity"
                value-format="object"
                placeholder="Type"
                @getData="onChangeConnectionJDC(data_action.connection)"/>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group :class="{'error-input' : $v.data_action.do_jdc.$error}">
              <label> Do </label>
              <j-single-select
                v-model="$v.data_action.do_jdc.$model"
                :error-required="$v.data_action.do_jdc.$error"
                :options="doOptionsDataConnectivity"
                placeholder="Do"/>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col>
            <b-form-group :class="{'error-input' : $v.data_action.query.$error}">
              <label> Query </label>
              <prism-editor
                v-model="$v.data_action.query.$model"
                :highlight="highlighter"
                :line-numbers="true"
                :class="{'dark-mode' : darkMode}"
                class="my-editor"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <div v-if="data_action.object === 'function'">
        <b-form-group :class="{'error-input' : $v.data_action.function_name.$error}">
          <label> Function Name </label>
          <j-single-select
            v-model="$v.data_action.function_name.$model"
            :error-required="$v.data_action.function_name.$error"
            :options="listFunction"
            :placeholder="'Select Function Name'"
            label="name"/>
        </b-form-group>
        <b-form-group >
          <label> Description </label>
          <j-textarea
            v-model="actionDescription"
            :error-required="false"
            :max-length="250"
            :disabled="true"
          />
        </b-form-group>
        <b-form-group :class="{'error-input' : $v.data_action.input.$error}">
          <b-row class="m__t--10">
            <b-col md="8">
              <label> Body </label>
            </b-col>
            <b-col
              md="3"
              class="p__r--1">
              <small class="pull-right">Dark Mode</small>
            </b-col>
            <b-col
              md="1"
              class="p__l--1">
              <j-toggle v-model="darkMode"/>
            </b-col>
          </b-row>
          <prism-editor
            v-model="$v.data_action.input.$model"
            :highlight="highlighter"
            :line-numbers="true"
            :class="{'dark-mode' : darkMode}"
            class="my-editor"
          />
        </b-form-group>
      </div>

      <div v-if="data_action.object === 'job'">
        <b-form-group :class="{'error-input' : $v.data_action.job_name.$error}">
          <label> Job Name </label>
          <j-single-select
            v-model="$v.data_action.job_name.$model"
            :error-required="$v.data_action.job_name.$error"
            :options="listJob"
            :placeholder="'Select Job Name'"
            label="name"/>
        </b-form-group>
        <b-form-group >
          <label> Description </label>
          <j-textarea
            v-model="actionDescription"
            :error-required="false"
            :max-length="250"
            :disabled="true"
          />
        </b-form-group>
        <b-form-group :class="{'error-input' : $v.data_action.input.$error}">
          <b-row class="m__t--10">
            <b-col md="8">
              <label> Body </label>
            </b-col>
            <b-col
              md="3"
              class="p__r--1">
              <small class="pull-right">Dark Mode</small>
            </b-col>
            <b-col
              md="1"
              class="p__l--1">
              <j-toggle v-model="darkMode"/>
            </b-col>
          </b-row>
          <prism-editor
            v-model="$v.data_action.input.$model"
            :highlight="highlighter"
            :line-numbers="true"
            :class="{'dark-mode' : darkMode}"
            class="my-editor"
          />
        </b-form-group>

        <div class="warning-function-vp d-flex align-items-center">
          <img
            :src="require('@/assets/icon/warning.svg')"
            alt="warning"
          >
          <div class="d-flex flex-column">
            <span class="title">Information</span>
            <span>
              Object Job will always be asynchronous
            </span>
          </div>
        </div>
      </div>

      <div v-if="data_action.object === 'dedicated_job'">
        <b-form-group :class="{'error-input' : $v.data_action.dedicated_job_name.$error}">
          <label> Dedicated Job Name </label>
          <j-single-select
            v-model="$v.data_action.dedicated_job_name.$model"
            :error-required="$v.data_action.dedicated_job_name.$error"
            :options="listDedicatedJob"
            :placeholder="'Select Dedicated Job Name'"
            label="name"/>
        </b-form-group>
        <b-form-group >
          <label> Description </label>
          <j-textarea
            v-model="actionDescription"
            :error-required="false"
            :max-length="250"
            :disabled="true"
          />
        </b-form-group>
        <b-form-group :class="{'error-input' : $v.data_action.input.$error}">
          <b-row class="m__t--10">
            <b-col md="8">
              <label> Body </label>
            </b-col>
            <b-col
              md="3"
              class="p__r--1">
              <small class="pull-right">Dark Mode</small>
            </b-col>
            <b-col
              md="1"
              class="p__l--1">
              <j-toggle v-model="darkMode"/>
            </b-col>
          </b-row>
          <prism-editor
            v-model="$v.data_action.input.$model"
            :highlight="highlighter"
            :line-numbers="true"
            :class="{'dark-mode' : darkMode}"
            class="my-editor"
          />
        </b-form-group>

        <div class="warning-function-vp d-flex align-items-center">
          <img
            :src="require('@/assets/icon/warning.svg')"
            alt="warning"
          >
          <div class="d-flex flex-column">
            <span class="title">Information</span>
            <span>
              Object Job will always be asynchronous
            </span>
          </div>
        </div>
      </div>

      <div v-if="data_action.object === 'joana'">
        <b-form-group :class="{'error-input' : $v.data_action.joana.group.$error}">
          <label> Dataset Group </label>
          <j-single-select
            v-model="$v.data_action.joana.group.$model"
            :error-required="$v.data_action.joana.group.$error"
            :options="datasetGroupOptions"
            placeholder="Select Dataset Group"
            value-format="object"
            label="name"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_action.joana.dataset.$error}">
          <label> Dataset </label>
          <j-single-select
            v-model="$v.data_action.joana.dataset.$model"
            :error-required="$v.data_action.joana.dataset.$error"
            :disabled="!data_action.joana.group"
            :options="datasetOptions"
            placeholder="Select Dataset"
            value-format="object"
            label="name"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_action.do.$error}">
          <label> Do </label>
          <j-single-select
            v-model="$v.data_action.do.$model"
            :error-required="$v.data_action.do.$error"
            :disabled="!data_action.joana.dataset"
            :options="doOptionsJoana"
            placeholder="Do"/>
        </b-form-group>

        <div
          v-if="data_action.do === 'execute_query'"
          class="dataset-page-query-container">
          <hr>
          <div
            class="btn-grey-query"
            @click="openListQuery">
            <img
              :src="require('@/assets/icon/query/open.svg')"
              width="13">
            Open Saved Query
          </div>

          <div class="d-flex">
            <div class="label-action-block">Query Box</div>
            <div
              :class="{ 'action-query-type-active' : query_type === 'sql' }"
              class="action-query-type"
              style="margin-left: 315px"
              @click="changeQueryType('sql')">SQL</div>
            <div
              :class="{ 'action-query-type-active' : query_type === 'mongodb' }"
              class="action-query-type"
              style="margin-left: 10px"
              @click="changeQueryType('mongodb')">MongoDB</div>
          </div>

          <j-monaco-editor
            ref="queryEditor"
            :value="dataQuery"
            :language="query_type === 'mongodb' ? 'json' : 'sql'"
            :disable-validate-json="true"
          />

          <div class="warning-function-vp d-flex align-items-center m__t--15">
            <img
              :src="require('@/assets/icon/warning.svg')"
              style="margin-top: -59px;"
              alt="warning"
            >
            <div class="d-flex flex-column">
              <span class="title">Information</span>
              <span>
                “limit” on query will have an impact on query performance, so please combine
                between limit and offset.
                (If you don’t use limit, the query will automatically run with limit 1000)
              </span>
            </div>
          </div>
        </div>

        <div v-if="data_action.do === 'update_record' || data_action.do === 'find_record' || data_action.do === 'find_records'">
          <hr>
          <span class="title-automation">Conditions</span>
          <small>"Where"</small>
          <div
            :class="{'error-input' : $v.data_action.conditions.$error}"
            class="conditions-wrap">
            <div
              :class="{'show-vertical-line' : data_action.conditions && data_action.conditions.length > 1,
                       'hide-vertical-line': data_action.conditions && data_action.conditions.length === 1 }"
              class="conditions-left">
              <div
                v-if="data_action.conditions && data_action.conditions.length > 1"
                class="conditions-vertical-line">
                <div/>
                <div class="v-line-top v-line"/>
                <div/>
              </div>
              <div class="conditions-operator">AND</div>
              <div
                v-if="data_action.conditions && data_action.conditions.length > 1"
                class="conditions-vertical-line">
                <div/>
                <div class="v-line-bottom v-line"/>
                <div/>
              </div>
            </div>
            <div class="conditions-right">
              <div
                v-if="data_action.conditions && data_action.conditions.length > 0"
                class="mb-2">
                <div
                  v-for="(item, index) in data_action.conditions"
                  :key="index"
                  :class="{'selected' : index === selectedIndexCondition}"
                  class="conditions-item-wrap">
                  <div class="field-item"> {{ item.field }} </div>
                  <div class="operator-item"> {{ item.operator ? item.operator === 'is_not_like' ? 'not like' : item.operator.replaceAll('_', ' ') : '' }} </div>
                  <div
                    v-if="item.operator !== 'between'"
                    class="value-item">
                    <span> {{ item.value }} </span>
                  </div>
                  <div
                    v-else
                    class="value-item">
                    {{ item.value[0] }}
                    <i class="fa fa-arrow-right mx-3"/>
                    {{ item.value[1] }}
                  </div>

                  <!-- Edit or Delete -->
                  <div class="edit-or-delete">
                    <div class="button">
                      <!-- Edit -->
                      <div
                        class="edit d-flex"
                        @click="openModalCondition(index)"
                      >
                        <i class="fa fa-pencil-square-o" />
                      </div>
                      <!-- Delete -->
                      <div
                        class="delete"
                        @click="deleteConditions(index)"
                      >
                        <i class="fa fa-trash" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="add-conditions"
                @click="openModalCondition()">+ Add Filter</div>
            </div>
          </div>
        </div>

        <div v-if="data_action.do === 'find_records'">
          <b-row>
            <b-col md="6">
              <b-form :class="{'error-input' : $v.data_action.sorting.key.$error}">
                <label> Sort By </label>
                <j-single-select
                  v-model="data_action.sorting.key"
                  :error-required="$v.data_action.sorting.key.$error"
                  :options="list_field"
                  :placeholder="'Sort by'"
                  value-format="object"
                  label="name"/>
              </b-form>
            </b-col>
            <b-col md="6">
              <b-form :class="{'error-input' : $v.data_action.sorting.order.$error}">
                <label> Order By </label>
                <j-single-select
                  v-model="data_action.sorting.order"
                  :error-required="$v.data_action.sorting.order.$error"
                  :options="orderOptions"
                  :placeholder="'Order by'"
                  value-format="object"
                  label="label"/>
              </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-form-group :class="{'error-input' : $v.data_action.page.$error}">
                <label> Page </label>
                <j-input
                  v-model="data_action.page"
                  :error-required="$v.data_action.page.$error"
                  placeholder="Page"/>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group :class="{'error-input' : $v.data_action.limit.$error}">
                <label> Limit </label>
                <j-input
                  v-model="data_action.limit"
                  :error-required="$v.data_action.limit.$error"
                  placeholder="Limit"/>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <div v-if="data_action.do === 'create_record' || data_action.do === 'update_record'">
          <hr>
          <span class="title-automation">List Fields</span>
          <j-form-record
            v-if="showBase"
            ref="jFormCreate"
            :data-fields="dataFields"
            :is-detail="dataEdit ? true : false"/>
        </div>

        <div v-if="data_action.do === 'create_records'">
          <hr>
          <span class="title-automation">Data Input</span>
          <b-form-group :class="{'error-input' : $v.data_action.input.$error}">
            <b-row>
              <b-col md="8">
                <label> Body </label>
              </b-col>
              <b-col md="4">
                <small
                  class="title-example-input-joana-create-records"
                  @click="toggleModalExample(true)">Example</small>
              </b-col>
            </b-row>
            <prism-editor
              v-model="$v.data_action.input.$model"
              :highlight="highlighter"
              :line-numbers="true"
              :class="{'dark-mode' : darkMode}"
              class="my-editor-block-joana"
            />
          </b-form-group>
        </div>
      </div>

      <div v-if="data_action.object === 'generate_file'">
        <!-- Section Properties -->
        <div class="section-border mb-3">
          <p class="title-section">File Properties</p>
          <p class="desc-section">File name, file type, extension and file storage configuration</p>

          <b-row>
            <div class="col-12 mb-2">
              <div>
                <label> Type </label>
                <div class="selections">
                  <div
                    v-for="option in fileTypeOptions"
                    :key="option.id"
                    :class="{
                      'selected': option.id === data_action.generate_file.type,
                      'error-input' : $v.data_action.generate_file.type.$error
                    }"
                    class="option"
                    @click="data_action.generate_file.type = option.id"
                  >
                    <img
                      :src="require(`@/assets/icon/file-${option.id}.svg`)"
                      :alt="option.text"
                    >
                    <p>{{ option.text }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-7 mb-2 pr-1">
              <b-form-group :class="{'error-input' : $v.data_action.generate_file.file_name.$error}">
                <label> Name </label>
                <j-input
                  v-model="data_action.generate_file.file_name"
                  placeholder="Input File Name"
                />
              </b-form-group>
            </div>

            <div class="col-5 mb-2 pl-1">
              <b-form-group :class="{'error-input' : $v.data_action.generate_file.extension.$error}">
                <label> Extension </label>
                <j-input
                  v-model="data_action.generate_file.extension"
                  placeholder="Input Extension"
                />
              </b-form-group>
            </div>

            <div class="col-12">
              <div class="company-drive-path">
                <b-form-group>
                  <label> Company Drive Path </label>
                  <j-input
                    v-model="data_action.generate_file.path"
                    placeholder="Input Path"
                  />
                </b-form-group>
                <i
                  class="fa fa-search icon-search"
                  @click="openModalCompanyDrive(false)"
                />
              </div>
            </div>
          </b-row>
        </div>

        <!-- Section Data -->
        <div class="section-border mb-3">
          <p class="title-section">Data</p>
          <p class="desc-section">Configuration of type, header, delimiter and content</p>

          <b-row>
            <div
              v-if="data_action.generate_file.type !== 'txt'"
              class="col-12"
            >
              <div class="mb-2">
                <label> Type </label>
                <div class="selections">
                  <div
                    v-for="option in dataTypeOptions"
                    :key="option.id"
                    :class="{
                      'selected': option.id === data_action.generate_file.data_type,
                      'error-input' : $v.data_action.generate_file.data_type.$error
                    }"
                    class="option"
                    @click="data_action.generate_file.data_type = option.id"
                  >
                    <p>{{ option.text }}</p>
                  </div>
                </div>
                <span class="info-field">Type of source content</span>
              </div>
            </div>

            <div :class="data_action.generate_file.type !== 'txt' ? 'col-7 pr-1' : 'col-12'">
              <b-form-group :class="{'error-input' : $v.data_action.generate_file.header.$error}">
                <label> Header </label>
                <j-input
                  v-model="data_action.generate_file.header"
                  placeholder="Input Header"
                />
              </b-form-group>
            </div>

            <div
              v-if="data_action.generate_file.type !== 'txt'"
              class="col-5 pl-1"
            >
              <b-form-group :class="{'error-input' : $v.data_action.delimiterSelected.$error}">
                <label> Delimiter </label>
                <j-single-select
                  v-model="data_action.delimiterSelected"
                  :options="delimiterOptions"
                  placeholder="Select Delimiter"
                />
              </b-form-group>
            </div>

            <div class="col-12 mt-2">
              <b-form-group
                v-if="data_action.delimiterSelected === 'other'"
                :class="{'error-input' : $v.data_action.generate_file.delimiter.$error}"
              >
                <label> Other Delimiter </label>
                <j-input
                  v-model="data_action.generate_file.delimiter"
                  placeholder="Input Other Delimiter"
                />
              </b-form-group>

              <b-form-group :class="{'error-input' : $v.data_action.generate_file.data.$error}">
                <label> Content </label>
                <j-input
                  v-model="data_action.generate_file.data"
                  placeholder="Input Data"
                />
              </b-form-group>
            </div>
          </b-row>
        </div>

        <div
          v-if="data_action.generate_file.type === 'csv'"
          class="section-border mb-3">
          <div class="d-flex">
            <div>
              <p class="title-section">Encryption</p>
              <p class="desc-section mb-1">
                Encryption in CSV generators refers to the process of encoding or scrambling the data within a CSV (Comma-Separated Values)
                file to protect it from unauthorized access or viewing. This security measure is crucial in situations where sensitive or confidential
                information is stored in CSV files, such as financial records, personal information, or proprietary data.
              </p>
            </div>
            <j-switch v-model="data_action.generate_file.encryption.active" />
          </div>

          <b-row v-if="data_action.generate_file.encryption.active">
            <div class="col-12 mb-1">
              <label> Algorithm </label>
              <div class="selections">
                <div class="selected option">
                  <p>AES256</p>
                </div>
              </div>
              <span class="info-field">Type of algorithm encryption</span>
            </div>

            <div class="col-12 mb-1">
              <label> Cipher Mode </label>
              <div class="selections">
                <div
                  :class="{
                    'selected': data_action.generate_file.encryption.cipher_mode === 'gcm',
                    'error-input' : $v.data_action.generate_file.encryption.cipher_mode.$error
                  }"
                  class="option"
                  @click="data_action.generate_file.encryption.cipher_mode = 'gcm'"
                >
                  <p>GCM</p>
                </div>
                <div
                  :class="{
                    'selected': data_action.generate_file.encryption.cipher_mode === 'cbc',
                    'error-input' : $v.data_action.generate_file.encryption.cipher_mode.$error
                  }"
                  class="option"
                  @click="data_action.generate_file.encryption.cipher_mode = 'cbc'"
                >
                  <p>CBC</p>
                </div>
              </div>
              <span class="info-field">Type of Cipher Mode Decryption</span>
            </div>

            <div class="col-12 mb-1">
              <label> Output Text Format </label>
              <div class="selections">
                <div
                  :class="{
                    'selected': data_action.generate_file.encryption.output_text_format === 'hex',
                    'error-input' : $v.data_action.generate_file.encryption.output_text_format.$error
                  }"
                  class="option"
                  @click="data_action.generate_file.encryption.output_text_format = 'hex'"
                >
                  <p>Hex</p>
                </div>
                <div
                  :class="{
                    'selected': data_action.generate_file.encryption.output_text_format === 'base64',
                    'error-input' : $v.data_action.generate_file.encryption.output_text_format.$error
                  }"
                  class="option"
                  @click="data_action.generate_file.encryption.output_text_format = 'base64'"
                >
                  <p>Base 64</p>
                </div>
              </div>
              <span class="info-field">Type of Text Format</span>
            </div>

            <div class="col-12 mb-1">
              <b-form-group :class="{'error-input' : $v.data_action.generate_file.encryption.initial_vector.$error}">
                <label> Initial Vector </label>
                <j-input
                  v-model="data_action.generate_file.encryption.initial_vector"
                  placeholder="Input Initial Vector"
                />
              </b-form-group>
            </div>

            <div class="col-12">
              <b-form-group :class="{'error-input' : $v.data_action.generate_file.encryption.secret_key.$error}">
                <label> Secret Key </label>
                <small class="info-label-config">Must be 32 char</small>
                <j-input
                  v-model="data_action.generate_file.encryption.secret_key"
                  :max-length="32"
                  placeholder="Input Secret Key"
                />
              </b-form-group>
            </div>
          </b-row>
        </div>
      </div>

      <div v-if="data_action.object === 'file_transfer_ftp'">
        <!-- Section Properties -->
        <div class="section-border mb-3">
          <p class="title-section">General</p>
          <p class="desc-section">Choose an action to be used for this action and a connection to a third party.</p>

          <b-row>
            <div class="col-12 mb-2">
              <b-form-group
                :class="{'error-input' : $v.data_action.file_transfer_ftp.do.$error}"
                class="mb-2"
              >
                <label>Do</label>
                <j-single-select
                  v-model="data_action.file_transfer_ftp.do"
                  :options="doOptionsFileTransfer"
                  placeholder="Select"
                />
              </b-form-group>
              <b-form-group
                :class="{'error-input' : $v.data_action.file_transfer_ftp.third_party_connection.$error}"
                class="mb-2"
              >
                <label>Third Party Connection</label>
                <j-single-select
                  v-model="data_action.file_transfer_ftp.third_party_connection"
                  :options="listThirdParty"
                  placeholder="Select Third Party Connection"
                  label="label"
                  @select="onChangeThirdPartyConnection"
                />
              </b-form-group>
              <!-- <div
                v-if="data_action.file_transfer_ftp.do === 'ftp_read_single_file' ||
                  data_action.file_transfer_ftp.do === 'ftp_get_list_directory' ||
                  data_action.file_transfer_ftp.do === 'ftp_upload' ||
                  data_action.file_transfer_ftp.do === 'ftp_download_single_file'
                "
                class="company-drive-path"
              >
                <b-form-group
                  :class="{
                    'error-input' : $v.data_action.file_transfer_ftp.source_file.$error ||
                      $v.data_action.file_transfer_ftp.destination_path.$error
                  }"
                >
                  <label> FTP Source File </label>
                  <j-input
                    v-if="data_action.file_transfer_ftp.do === 'ftp_read_single_file' || data_action.file_transfer_ftp.do === 'ftp_get_list_directory'"
                    v-model="data_action.file_transfer_ftp.source_path"
                    placeholder="Input FTP Source File"
                  />
                  <j-input
                    v-if="data_action.file_transfer_ftp.do === 'ftp_upload' || data_action.file_transfer_ftp.do === 'ftp_download_single_file'"
                    v-model="data_action.file_transfer_ftp.source_path"
                    placeholder="Input FTP Source File"
                  />
                </b-form-group>
                <i
                  class="fa fa-search icon-search"
                  @click="openModalFtp"
                />
              </div> -->

              <!-- Source File -->
              <b-form-group
                v-if="data_action.file_transfer_ftp.do === 'ftp_read_single_file' || data_action.file_transfer_ftp.do === 'ftp_get_list_directory'"
                :class="{'error-input' : $v.data_action.file_transfer_ftp.source_path.$error}"
                class="mb-2"
              >
                <label>FTP Source File</label>
                <j-input
                  v-model="data_action.file_transfer_ftp.source_path"
                  placeholder="Type FTP Source File"
                />
              </b-form-group>
              <b-form-group
                v-if="data_action.file_transfer_ftp.do === 'ftp_download_single_file'"
                :class="{'error-input' : $v.data_action.file_transfer_ftp.source_file.$error}"
                class="mb-2"
              >
                <label>FTP Source File</label>
                <j-input
                  v-model="data_action.file_transfer_ftp.source_file"
                  placeholder="Input FTP Source File"
                />
              </b-form-group>
              <div
                v-if="data_action.file_transfer_ftp.do === 'ftp_upload'"
                class="company-drive-path"
              >
                <b-form-group :class="{'error-input' : $v.data_action.file_transfer_ftp.source_file.$error}">
                  <label> Company Drive Source File </label>
                  <j-input
                    v-model="data_action.file_transfer_ftp.source_file"
                    placeholder="Input Company Drive Source File"
                  />
                </b-form-group>
                <i
                  class="fa fa-search icon-search"
                  @click="openModalCompanyDrive(true)"
                />
              </div>
              <b-form-group
                v-if="data_action.file_transfer_ftp.do === 'ftp_move_single_file' || data_action.file_transfer_ftp.do === 'ftp_delete_single_file'"
                :class="{'error-input' : $v.data_action.file_transfer_ftp.ftp_source_file_path.$error}"
                class="mb-2"
              >
                <label>FTP Source File Path</label>
                <j-input
                  v-model="data_action.file_transfer_ftp.ftp_source_file_path"
                  placeholder="Input FTP Source File Path"
                />
              </b-form-group>

              <!-- Destination Path -->
              <div
                v-if="data_action.file_transfer_ftp.do === 'ftp_download_single_file'"
                class="company-drive-path"
              >
                <b-form-group :class="{'error-input' : $v.data_action.file_transfer_ftp.destination_path.$error}">
                  <label> Company Drive Path </label>
                  <j-input
                    v-model="data_action.file_transfer_ftp.destination_path"
                    placeholder="Input Company Drive Path"
                  />
                </b-form-group>
                <i
                  class="fa fa-search icon-search"
                  @click="openModalCompanyDrive(false)"
                />
              </div>
              <b-form-group
                v-if="data_action.file_transfer_ftp.do === 'ftp_upload'"
                :class="{'error-input' : $v.data_action.file_transfer_ftp.destination_path.$error}"
                class="mb-2"
              >
                <label>FTP Path</label>
                <j-input
                  v-model="data_action.file_transfer_ftp.destination_path"
                  placeholder="Input FTP Path"
                />
              </b-form-group>
              <b-form-group
                v-if="data_action.file_transfer_ftp.do === 'ftp_move_single_file'"
                :class="{'error-input' : $v.data_action.file_transfer_ftp.ftp_destination_folder.$error}"
                class="mb-2"
              >
                <label>FTP Destination Folder</label>
                <j-input
                  v-model="data_action.file_transfer_ftp.ftp_destination_folder"
                  placeholder="Input FTP Destination Folder"
                />
              </b-form-group>
            </div>
          </b-row>
        </div>

        <!-- Section File Properties -->
        <div
          v-if="data_action.file_transfer_ftp.do === 'ftp_read_single_file'"
          class="section-border mb-3"
        >
          <p class="title-section">File Properties</p>
          <p class="desc-section">File name, file type, extension and file storage configuration.</p>

          <b-row>
            <div class="col-12">
              <div class="mb-2">
                <label> Type </label>
                <div class="selections">
                  <div
                    v-for="option in fileTypeOptions"
                    :key="option.id"
                    :class="{
                      'selected': option.id === data_action.file_transfer_ftp.extension,
                      'error-input' : $v.data_action.file_transfer_ftp.extension.$error
                    }"
                    class="option"
                    @click="data_action.file_transfer_ftp.extension = option.id"
                  >
                    <img
                      :src="require(`@/assets/icon/file-${option.id}.svg`)"
                      :alt="option.text"
                    >
                    <p>{{ option.text }}</p>
                  </div>
                </div>
                <span class="info-field">Type of source content</span>
              </div>
            </div>
            <div class="col-6 pr-1">
              <b-form-group>
                <label> Delimiter </label>
                <j-single-select
                  v-model="data_action.delimiterSelected"
                  :options="delimiterOptions"
                  placeholder="Select Delimiter"
                />
              </b-form-group>
            </div>
            <div
              v-if="data_action.delimiterSelected === 'other'"
              class="col-6 pl-1"
            >
              <b-form-group>
                <label> Other Delimiter </label>
                <j-input
                  v-model="data_action.file_transfer_ftp.delimiter"
                  placeholder="Input Other Delimiter"
                />
              </b-form-group>
            </div>
          </b-row>
        </div>
      </div>

      <!-- Compress File -->
      <div v-if="data_action.object === 'compress_file'">
        <div class="section-border mb-3">
          <b-row>
            <div class="col-7 mb-2">
              <b-form-group :class="{'error-input' : $v.data_action.compress_file.name.$error}">
                <label>Name</label>
                <j-input
                  v-model="data_action.compress_file.name"
                  placeholder="Type File Name"
                />
              </b-form-group>
            </div>
            <div class="col-5 mb-2">
              <b-form-group :class="{'error-input' : $v.data_action.compress_file.compress_type.$error}">
                <label>Compression Format</label>
                <j-single-select
                  v-model="data_action.compress_file.compress_type"
                  :options="compressTypeOptions"
                  placeholder="Select Format"
                />
              </b-form-group>
            </div>
            <div class="col-12 mb-2">
              <b-form-group>
                <label>Set Password</label>
                <j-input
                  v-model="data_action.compress_file.password"
                  placeholder="Enter Password"
                />
              </b-form-group>
            </div>
            <div class="col-12">
              <div class="company-drive-path">
                <b-form-group :class="{'error-input' : $v.data_action.compress_file.destination_folder.$error}">
                  <label> Company Drive Destination Folder </label>
                  <j-input
                    v-model="data_action.compress_file.destination_folder"
                    placeholder="Input Destination Folder Path"
                  />
                </b-form-group>
                <i
                  class="fa fa-search icon-search"
                  @click="openModalCompanyDrive(false)"
                />
              </div>
            </div>
          </b-row>
        </div>

        <!-- Section Data -->
        <div class="section-border mb-3">
          <p class="title-section">Data</p>
          <p class="desc-section">Configuration source of file to compression</p>

          <b-row>
            <div class="col-12 mb-3">
              <label> Type </label>
              <div class="selections">
                <div
                  v-for="option in typeFileCompressOptions"
                  :key="option.id"
                  :class="{
                    'selected': option.id === data_action.compress_file.do,
                    'error-input' : $v.data_action.compress_file.do.$error
                  }"
                  class="option"
                  @click="data_action.compress_file.do = option.id"
                >
                  <p>{{ option.text }}</p>
                </div>
              </div>
              <span class="info-field">Type of source content</span>
            </div>
            <div class="col-12">
              <b-form-group
                v-if="data_action.compress_file.do === 'base64' || data_action.compress_file.do === 'multiple_url'"
                :class="{
                  'error-input' : $v.data_action.compress_file.dataBase64.$error ||
                    $v.data_action.compress_file.dataPublicUrl.$error
                }"
              >
                <label> Content </label>
                <j-textarea
                  v-if="data_action.compress_file.do === 'base64'"
                  v-model="data_action.compress_file.dataBase64"
                  placeholder="Fill Base64 format"
                />
                <j-textarea
                  v-else-if="data_action.compress_file.do === 'multiple_url'"
                  v-model="data_action.compress_file.dataPublicUrl"
                  placeholder="Fill array Public URL can Officeless Access"
                />
              </b-form-group>
              <div
                v-else-if="data_action.compress_file.do === 'company_drive'"
                class="company-drive-path"
              >
                <b-form-group :class="{'error-input' : $v.data_action.compress_file.dataCompanyDrive.$error}">
                  <label> Content </label>
                  <j-input
                    v-model="data_action.compress_file.dataCompanyDrive"
                    placeholder="Fill array of File Path Company Drive"
                  />
                </b-form-group>
                <i
                  class="fa fa-search icon-search"
                  @click="openModalCompanyDrive(true, true)"
                />
              </div>
            </div>
          </b-row>
        </div>
      </div>

      <!-- Configuration -->
      <div
        v-if="data_action.do === 'find_record' ||
          data_action.do === 'find_records' ||
          data_action.do === 'create_record' ||
          data_action.do === 'create_records' ||
          data_action.do === 'delete_record' ||
          data_action.do === 'update_record' ||
          data_action.object === 'call_webhook' ||
          data_action.object === 'data_connectivity' ||
          data_action.object === 'function' ||
          data_action.object === 'joana' ||
          data_action.object === 'generate_file' ||
          data_action.object === 'file_transfer_ftp' ||
          data_action.object === 'compress_file'
        "
        class="section-border mt-3 mb-4"
      >
        <p class="title-section">Configuration</p>
        <p class="desc-section">Additional Action block feature</p>

        <!-- Run History -->
        <div
          v-if="data_action.do === 'find_record' ||
            data_action.do === 'find_records' ||
            data_action.do === 'create_record' ||
            data_action.do === 'create_records' ||
            data_action.do === 'delete_record' ||
            data_action.do === 'update_record' ||
            data_action.object === 'call_webhook' ||
            data_action.object === 'data_connectivity' ||
            data_action.object === 'function' ||
            data_action.object === 'joana' ||
            data_action.object === 'generate_file' ||
            data_action.object === 'file_transfer_ftp' ||
            data_action.object === 'compress_file'
          "
          class="config-toggle">
          <div class="wrap-config-toggle-desc">
            <p class="title-config-toggle">Disable Run History</p>
            <p class="desc-config-toggle">
              To improve performance, the result of the block will be disabled in the run history. Container variables can still be used to store block execution results.
            </p>
          </div>
          <j-switch v-model="data_action.is_disable_log" />
        </div>

        <!-- Async -->
        <div
          v-if="data_action.do === 'find_record' ||
            data_action.do === 'find_records' ||
            data_action.do === 'create_record' ||
            data_action.do === 'delete_record' ||
            data_action.do === 'update_record' ||
            data_action.object === 'call_webhook' ||
            data_action.object === 'data_connectivity' ||
            data_action.object === 'function' ||
            data_action.object === 'generate_file' ||
            data_action.object === 'file_transfer_ftp' ||
            data_action.object === 'compress_file'
          "
          class="config-toggle"
        >
          <div class="wrap-config-toggle-desc">
            <p class="title-config-toggle">Asynchronous</p>
            <p class="desc-config-toggle">
              Processing Block that allows  to execute tasks simultaneously without having to wait for previous tasks to complete first.
            </p>
          </div>
          <j-switch v-model="data_action.is_async" />
        </div>

        <!-- Disable Audit Trail -->
        <div
          v-if=" data_action.object === 'form' &&
            (data_action.do === 'create_record' ||
            data_action.do === 'create_records')
          "
          class="config-toggle"
        >
          <div class="wrap-config-toggle-desc">
            <p class="title-config-toggle">Disable Audit Trail</p>
            <p class="desc-config-toggle">
              Activity logs can be disabled based on business process requirements or security needs.
            </p>
          </div>
          <j-switch v-model="data_action.is_disable_audit_trail" />
        </div>

        <!-- Backup company drive -->
        <div
          v-if="data_action.object === 'file_transfer_ftp' && data_action.file_transfer_ftp.do === 'ftp_delete_single_file'"
          class="config-toggle"
        >
          <div class="wrap-config-toggle-desc">
            <p class="title-config-toggle">Backup to company drive</p>
            <p class="desc-config-toggle">
              Feature for backing up files that will be deleted on the FTP server. File will be store on company drive folder “Deleted File FTP”
            </p>
          </div>
          <j-switch v-model="data_action.file_transfer_ftp.backup_to_company_drive" />
        </div>
      </div>

      <div
        v-if="
          data_action.do === 'find_record' ||
            data_action.do === 'find_records' ||
            data_action.do === 'create_record' ||
            data_action.do === 'create_records' ||
            data_action.do === 'delete_record' ||
            data_action.do === 'update_record' ||
            data_action.object === 'call_webhook' ||
            data_action.object === 'function' ||
            data_action.object === 'joana' ||
            data_action.object === 'send_notification' ||
            data_action.object === 'data_connectivity' ||
            data_action.object === 'generate_file' ||
            data_action.object === 'file_transfer_ftp' ||
            data_action.object === 'compress_file'
        "
      >
        <hr>
        <span
          v-if="
            data_action.do === 'find_record' ||
              data_action.do === 'find_records' ||
              data_action.do === 'create_record' ||
              data_action.do === 'create_records' ||
              data_action.do === 'delete_record' ||
              data_action.do === 'update_record' ||
              data_action.object === 'call_webhook' ||
              data_action.object === 'function' ||
              data_action.object === 'joana' ||
              data_action.object === 'generate_file' ||
              data_action.object === 'file_transfer_ftp' ||
              data_action.object === 'compress_file'
          "
          class="title-automation"
        >
          Container
        </span>
        <span
          v-if="data_action.object === 'send_notification' || data_action.object === 'data_connectivity'"
          class="title-automation"
        >
          Container Variable
        </span>
        <b-form-group :class="{'error-input' : $v.data_action.variable_name.$error}">
          <label> Variable Name </label>
          <j-input
            v-model="$v.data_action.variable_name.$model"
            :error-required="$v.data_action.variable_name.$error"
            :max-length="255"
            placeholder="Variable Name"/>
        </b-form-group>
      </div>
    </div>

    <div v-show="!onProperties">
      <b-row
        v-if="dataEdit && showContainer && objectType"
        class="m__t--10">
        <b-col
          md="2"
          class="p__r--1">
          <img
            v-if="objectType === 'form'"
            :src="require('@/assets/automation/data_manager.svg')"
            width="35"
            height="35"
            class="m__t--5">
          <img
            v-if="objectType === 'notif'"
            :src="require('@/assets/automation/notif.svg')"
            width="35"
            height="35"
            class="m__t--5">
          <img
            v-if="objectType === 'connectivity'"
            :src="require('@/assets/automation/connectivity.svg')"
            width="35"
            height="35"
            class="m__t--5">
          <img
            v-if="objectType === 'webhook'"
            :src="require('@/assets/automation/api.svg')"
            width="35"
            height="35"
            class="m__t--5">
          <img
            v-if="objectType === 'function'"
            :src="require('@/assets/automation/function.svg')"
            width="35"
            height="35"
            class="m__t--5">
          <img
            v-if="objectType === 'job' || objectType === 'dedicated_job'"
            :src="require('@/assets/automation/job.svg')"
            width="35"
            height="35"
            class="m__t--5">
          <img
            v-if="objectType === 'joana'"
            :src="require('@/assets/automation/joana.svg')"
            width="35"
            height="35"
            class="m__t--5">
          <img
            v-if="objectType === 'generate_file'"
            :src="require('@/assets/automation/generate_file_gray.svg')"
            width="35"
            height="35"
            class="m__t--5">
          <img
            v-if="objectType === 'file_transfer_ftp'"
            :src="require('@/assets/automation/file_transfer_gray.svg')"
            width="35"
            height="35"
            class="m__t--5">
          <img
            v-if="objectType === 'compress_file'"
            :src="require('@/assets/automation/compress_file_gray.svg')"
            width="35"
            height="35"
            class="m__t--5">
        </b-col>
        <b-col
          v-if="objectType === 'form'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">
            {{ data_action.form ? data_action.form.name : '' }}
          </div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ eventLabel }}
          </div>
        </b-col>
        <b-col
          v-if="objectType === 'notif'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">
            {{ dataEdit.type === 'send_email' ? 'Email' : 'Push Notification' }}
          </div>
          <div class="trigger__label-event ellipsis m__l--10">
            Send Notification
          </div>
        </b-col>
        <b-col
          v-if="objectType === 'connectivity'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">
            {{ data_action.connection ? data_action.connection.connection_name : '' }}
          </div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ data_action.do_jdc === 'exec_record' ? 'Execution' : 'Fetch' }}
          </div>
        </b-col>
        <b-col
          v-if="objectType === 'webhook'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">
            Hit External API
          </div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ data_action.url }}
          </div>
        </b-col>
        <b-col
          v-if="objectType === 'function'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">
            Hit Function
          </div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ data_action.function_name }}
          </div>
        </b-col>
        <b-col
          v-if="objectType === 'job'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">
            Job
          </div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ data_action.job_name }}
          </div>
        </b-col>
        <b-col
          v-if="objectType === 'dedicated_job'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">
            Dedicated Job
          </div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ data_action.dedicated_job_name }}
          </div>
        </b-col>
        <b-col
          v-if="objectType === 'joana'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">
            {{ data_action.joana.dataset ? data_action.joana.dataset.name : '' }}
          </div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ eventLabelJoana }}
          </div>
        </b-col>
        <b-col
          v-if="objectType === 'generate_file'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">Generate File</div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ dataEdit.type === 'generate_file_csv'? 'Generate csv' : 'Generate txt' }}
          </div>
        </b-col>
        <b-col
          v-if="objectType === 'file_transfer_ftp'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">File Transfer</div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ labelFileTransfer }}
          </div>
        </b-col>
        <b-col
          v-if="objectType === 'compress_file'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">File Compression</div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ labelCompressFile }}
          </div>
        </b-col>
      </b-row>
      <div
        v-if="dataEdit && showContainer && (objectType !== 'job' && objectType !== 'dedicated_job')"
        class="trigger__label-variable ellipsis m__t--10">
        <img
          :src="require('@/assets/automation/variable.png')"
          width="20"
          height="20"
          class="m__r--10">
        {{ dataEdit.container_variable }}
      </div>
    </div>

    <b-modal
      v-if="onProperties"
      ref="listSavedQueryModal"
      class="mod-form modal-add-record-data dataset-page-query-container"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">OPEN SAVED QUERY</div>

      <div
        v-if="listQuerySaved.length > 0"
        class="container-list-query-saved">
        <div
          v-for="(item, index) in listQuerySaved"
          :key="index"
          :class="{ 'm__t--10' : index > 0,
                    'list-query-active' : item.id === (querySelected ? querySelected.id : '') }"
          class="list-query"
          @click="querySelected = item">
          <img
            :src="require(`@/assets/icon/query/radio-${item.id === (querySelected ? querySelected.id : '') ? 'on' : 'off'}.svg`)"
            width="20">
          <div class="m__l--10">
            <div class="label-query">{{ item.name }}</div>
            <div class="d-flex">
              <div
                v-show="item.query_type"
                class="content-type-query">{{ item.query_type }}</div>
              <div class="id-query">#{{ item.id }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>No data option</div>

      <b-row>
        <b-col md="12">
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeModalListSaved">
              Close
            </b-button>
            <b-button
              :disabled="!querySelected"
              class="btn blue"
              @click="openQuerySelected">
              Open
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <modal-condition-action-block
      v-if="onProperties && isOpenModalCondition"
      ref="modalCondition"
      :list-field="list_field"
      :data="dataItemCondition"
      :columns="getDataColumnsByObject"
      :conditions="data_action.conditions"
      :type="data_action.object"
      @submit="submitModalCondition"
      @close="toggleModalCondition(false)"
    />

    <modal-example-action-block
      v-if="onProperties && isOpenModalExample"
      ref="modalExample"
      :columns="dataColumnDataset"
      @close="toggleModalExample(false)"
    />

    <modal-company-drive
      v-if="isOpenModalCompanyDrive"
      :is-multiple="multipleSourceFile"
      @close-popup="handleCloseModalCompanyDrive"
    />

    <modal-ftp
      v-if="isOpenModalFtp"
      :third-party="detailThirdParty"
      @close-popup="handleCloseModalFtp"
    />
  </div>
</template>

<script>
/* eslint-disable max-len, no-console, no-useless-escape, no-nested-ternary, no-unused-vars, no-plusplus, no-trailing-spaces, consistent-return */
import { required, requiredIf, minLength } from 'vuelidate/lib/validators';
import { mapActions, mapState, mapMutations } from 'vuex';
import draggable from 'vuedraggable';
import jwtDecode from 'jwt-decode';
import jApiDataConnectivity from '@/services/jApiDataConnectivity';
import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';
import ModalConditionActionBlock from '@/views/visual-programming/popup/ModalConditionActionBlock';
import ModalExampleActionBlock from '@/views/visual-programming/popup/ModalExampleActionBlock';
import ModalCompanyDrive from '@/views/visual-programming/popup/ModalCompanyDrive';
import ModalFtp from '@/views/visual-programming/popup/ModalFtp';
import jSwitch from '@/components/inputs/jSwitch';

// Mixins
import jMixPanZoom from '@/mixins/visual-programming/jMixPanZoom';
import jMixAutomation from '@/mixins/visual-programming/jMixAutomation';

import { highlight, languages } from 'prismjs/components/prism-core';
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-sql';
import 'prismjs/themes/prism-tomorrow.css';
import '../../services/jApiAutomation';

export default {
  name: 'JAutomationAction',
  components: {
    draggable,
    PrismEditor,
    jMonacoEditor,
    ModalConditionActionBlock,
    ModalExampleActionBlock,
    ModalCompanyDrive,
    ModalFtp,
    jSwitch,
  },
  mixins: [
    jMixPanZoom,
    jMixAutomation,
  ],
  props: {
    id: {
      type: Number,
      default: 0,
    },
    dataIndex: {
      type: Number,
      default: 0,
    },
    dataIndexParent: {
      type: Number,
      default: 0,
    },
    dataPosition: {
      type: String,
      default: '',
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
    onProperties: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Number,
      default: 0,
    },
    dataParent: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isFirstLoad: true,
      popOverJDCShow: false,
      dataConnectionDescription: '',
      data_action: {
        object: null,
        // Form
        table_group: null,
        form: null,
        do: null,
        variable_name: '',
        conditions: [
          {
            field: null,
            operator: null,
            value: '',
          },
        ],
        query: '',
        sorting: {
          key: null,
          order: null,
        },
        page: null,
        limit: null,
        // Call Webhook
        method: null,
        url: '',
        body: '',
        column: [
          {
            name: '',
            value: '',
          },
        ],
        content_type: null,
        // Send Notification
        type: null,
        to_email: null,
        cc: null,
        bcc: null,
        subject: '',
        message: '',
        // push notif
        push_notif_to: '',
        push_notif_content: '',
        push_notif_heading: '',
        is_custom_redirect: false,
        script_redirect: '',
        variable_redirect: '',

        variable_name_container: '',

        connection: null,
        do_jdc: null,
        // Function
        function_name: null,
        input: '',
        job_name: null,
        dedicated_job_name: null,

        is_disable_log: false,
        is_async: false,
        is_disable: false,
        is_disable_audit_trail: false,

        // Joana
        joana: {
          group: null,
          dataset: null,
        },

        // Generate File
        generate_file: {
          type: null,
          extension: null,
          file_name: null,
          data_type: null,
          header: null,
          data: null,
          delimiter: null,
          path: null,
          encryption: {
            active: false,
            algorithm: 'aes256',
            cipher_mode: null,
            output_text_format: null,
            initial_vector: null,
            secret_key: null,
          },
        },
        delimiterSelected: null,

        // File transfer
        file_transfer_ftp: {
          do: null,
          third_party_connection: null,
          source_file: null,
          source_path: null,
          ftp_source_file_path: null,
          destination_path: null,
          ftp_destination_folder: null,
          backup_to_company_drive: null,
          extension: null,
          compress: null,
          delimiter: null,
        },

        // File compression
        compress_file: {
          do: 'base64',
          dataBase64: null,
          dataPublicUrl: null,
          dataCompanyDrive: null,
          name: null,
          compress_type: null,
          password: null,
          destination_folder: null,
        },
      },

      disable_block: false,
      detailThirdParty: {},
      editorOption: {},
      listFunction: [],
      listJob: [],
      listDedicatedJob: [],
      dataFields: [],
      list_field: [],
      darkMode: false,
      showBase: false,
      blockActive: false,
      blockError: false,
      dataColumnDataset: [],
      dataQuery: '\n\n\n\n\n\n',
      query_type: 'sql',
      querySelected: null,
      listQuerySaved: [],
      datasetGroupOptions: [],
      datasetOptions: [],
      loadOptionsDataConnectivity: [],
      tableGroupOptions: [],
      tableOptions: [],
      listThirdParty: [],
      showContainer: false,
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      isOpenModalCondition: false,
      selectedIndexCondition: null,
      dataItemCondition: null,
      finishSetDataTableGroup: false,
      isOpenModalExample: false,
      isOpenModalCompanyDrive: false,
      isOpenModalFtp: false,
      multipleSourceFile: false,
      isOpenCompDriveFromContentCompressFile: false,
      versionFilter: 'v1',

      objectOptions: [
        {
          id: 'joana',
          text: 'Big Data Engine',
        },
        {
          id: 'data_connectivity',
          text: 'Data Connectivity',
        },
        {
          id: 'form',
          text: 'Data Manager',
        },
        {
          id: 'call_webhook',
          text: 'Hit External API',
        },
        {
          id: 'function',
          text: 'Hit Function',
        },
        {
          id: 'job',
          text: 'Job',
        },
        {
          id: 'dedicated_job',
          text: 'Dedicated Job',
        },
        {
          id: 'send_notification',
          text: 'Send Notification',
        },
        {
          id: 'generate_file',
          text: 'Generate File',
        },
        {
          id: 'file_transfer_ftp',
          text: 'File Transfer',
        },
        // {
        //   id: 'compress_file',
        //   text: 'File Compression',
        // },
      ],
      doOptionsDataConnectivity: [
        {
          id: 'exec_record',
          text: 'Exec',
        },
        {
          id: 'find_record',
          text: 'Fetch',
        },
      ],
      doOptions: [
        {
          id: 'create_record',
          text: 'Create Record',
        },
        {
          id: 'create_records',
          text: 'Create Records',
        },
        {
          id: 'find_record',
          text: 'Find Record',
        },
        {
          id: 'find_records',
          text: 'Find Records',
        },
        {
          id: 'update_record',
          text: 'Update Record',
        },
        {
          id: 'delete_record',
          text: 'Delete Record',
        },
      ],
      doOptionsJoana: [
        {
          id: 'create_record',
          text: 'Create Record',
        },
        {
          id: 'create_records',
          text: 'Create Records',
        },
        {
          id: 'find_record',
          text: 'Find Record',
        },
        {
          id: 'find_records',
          text: 'Find Records',
        },
        {
          id: 'update_record',
          text: 'Update Record',
        },
        {
          id: 'execute_query',
          text: 'Execute Query',
        },
      ],
      doOptionsFileTransfer: [
        {
          id: 'ftp_read_single_file',
          text: 'Read Single File',
        },
        {
          id: 'ftp_get_list_directory',
          text: 'Get List Directory',
        },
        {
          id: 'ftp_download_single_file',
          text: 'Download Single File',
        },
        {
          id: 'ftp_upload',
          text: 'Upload',
        },
        {
          id: 'ftp_move_single_file',
          text: 'Move Single File',
        },
        {
          id: 'ftp_delete_single_file',
          text: 'Delete Single File',
        },
      ],
      operatorOptions: [
        {
          id: 'is',
          text: 'Is',
        },
      ],
      typeNotifOptions: [
        {
          id: 'send_email',
          text: 'Email',
        },
        {
          id: 'send_notification',
          text: 'Push Notification',
        },
      ],
      typeFileOptions: [
        {
          id: 'csv',
          text: 'CSV',
        },
        {
          id: 'txt',
          text: 'TXT',
        },
        {
          id: 'xls',
          text: 'XLS',
        },
        {
          id: 'xlsx',
          text: 'XLSX',
        },
      ],
      typeTransformOptions: [
        {
          id: 'base64',
          text: 'Base64',
        },
      ],
      typeFileCompressOptions: [
        {
          id: 'base64',
          text: 'Base64',
        },
        {
          id: 'multiple_url',
          text: 'Public URL',
        },
        {
          id: 'company_drive',
          text: 'File Path Company Drive',
        },
      ],
      methodOptions: [
        {
          id: 'post',
          text: 'POST',
        },
        {
          id: 'get',
          text: 'GET',
        },
        {
          id: 'delete',
          text: 'DELETE',
        },
      ],
      contentTypeOptions: [
        {
          id: 'json',
          text: 'JSON',
        },
      ],
      orderOptions: [
        {
          id: 'asc',
          label: 'Ascending',
          text: 'Ascending',
        },
        {
          id: 'desc',
          label: 'Descending',
          text: 'Descending',
        },
      ],
      fileTypeOptions: [
        {
          id: 'csv',
          text: 'CSV',
        },
        {
          id: 'txt',
          text: 'TXT',
        },
      ],
      dataTypeOptions: [
        {
          id: 'array',
          text: 'Array',
        },
        {
          id: 'object',
          text: 'Array of Object',
        },
      ],
      delimiterOptions: [
        {
          id: ';',
          text: '(;) Semicolon',
        },
        {
          id: ',',
          text: '(,) Comma',
        },
        {
          id: '\t',
          text: '(\\t) Tab',
        },
        {
          id: ' ',
          text: '( ) Space',
        },
        {
          id: 'other',
          text: 'Other',
        },
      ],
      compressTypeOptions: [
        {
          id: 'zip',
          text: 'Zip',
        },
        {
          id: 'tar',
          text: 'Tar',
        },
      ],
    };
  },
  computed: {
    ...mapState('jStoreAutomation', ['propertiesOpened', 'propertiesIDBlock', 'dataDoAction']),
    ...mapState('jStoreThirdParty', ['list_connection']),

    objectOptionsFiltered() {
      if (process.env.BIG_DATA_ENGINE_MENU !== 'true') {
        return this.objectOptions.filter(f => f.id !== 'joana');
      }
      return this.objectOptions;
    },

    objectType() {
      let type = '';
      if (this.dataEdit) {
        const formType = this.doOptions.find(f => f.id === this.dataEdit.type);
        const notifEmail = this.typeNotifOptions.find(f => f.id === this.dataEdit.type);
        if (formType) {
          type = 'form';
        } else if (notifEmail) {
          type = 'notif';
        } else if (this.dataEdit.type === 'data_connectivity') {
          type = 'connectivity';
        } else if (this.dataEdit.type === 'function') {
          type = 'function';
        } else if (this.dataEdit.type === 'job') {
          type = 'job';
        } else if (this.dataEdit.type === 'dedicated_job') {
          type = 'dedicated_job';
        } else if (this.dataEdit.type === 'joana') {
          type = 'joana';
        } else if (
          this.dataEdit.type === 'generate_file_csv' ||
          this.dataEdit.type === 'generate_file_text'
        ) {
          type = 'generate_file';
        } else if (
          this.dataEdit.type === 'ftp_read_single_file' ||
          this.dataEdit.type === 'ftp_get_list_directory' ||
          this.dataEdit.type === 'ftp_download_single_file' ||
          this.dataEdit.type === 'ftp_upload' ||
          this.dataEdit.type === 'ftp_move_single_file' ||
          this.dataEdit.type === 'ftp_delete_single_file'
        ) {
          type = 'file_transfer_ftp';
        } else if (
          this.dataEdit.type === 'compress_file_base64' ||
          this.dataEdit.type === 'compress_file_multiple_url' ||
          this.dataEdit.type === 'compress_file_company_drive'
        ) {
          type = 'compress_file';
        } else {
          type = 'webhook';
        }
      }
      return type;
    },

    eventLabel() {
      const event = this.doOptions.find(f => f.id === this.dataEdit.type);
      return event ? event.text : '';
    },

    eventLabelJoana() {
      const doing = this.dataEdit.joana ? this.dataEdit.joana.do : '';
      const event = this.doOptionsJoana.find(f => f.id === doing);
      return event ? event.text : '';
    },

    selectedObject() {
      switch (this.data_action.object) {
        case 'call_webhook':
          return {
            img: 'api',
            title: 'Hit External API',
          };
        case 'send_notification':
          return {
            img: 'notif',
            title: 'Send Notification',
          };
        case 'data_connectivity':
          return {
            img: 'connectivity',
            title: 'Data Connectivity',
          };
        case 'function':
          return {
            img: 'function',
            title: 'Hit Function',
          };
        case 'job':
          return {
            img: 'job',
            title: 'Job',
          };
        case 'dedicated_job':
          return {
            img: 'job',
            title: 'Dedicated Job',
          };
        case 'joana':
          return {
            img: 'joana_colored',
            title: 'Big Data Engine',
          };
        case 'generate_file':
          return {
            img: 'generate_file',
            title: 'Generate File',
          };
        case 'file_transfer_ftp':
          return {
            img: 'file_transfer',
            title: 'File Transfer',
          };
        case 'compress_file':
          return {
            img: 'compress_file',
            title: 'File Compression',
          };
        default:
          return {
            img: 'data_manager',
            title: 'Data Manager',
          };
      }
    },

    labelFileTransfer() {
      const type = this.data_action.file_transfer_ftp.do;
      if (type === 'ftp_upload') return 'Upload';
      else if (type === 'ftp_download_single_file') return 'Download single file';
      else if (type === 'ftp_read_single_file') return 'Read single file';
      else if (type === 'ftp_get_list_directory') return 'Get list directory';
      else if (type === 'ftp_move_single_file') return 'Move single file';
      else if (type === 'ftp_delete_single_file') return 'Delete single file';
      return '';
    },

    labelCompressFile() {
      const type = this.data_action.compress_file.do;
      if (type === 'base64') return 'Base64';
      else if (type === 'multiple_url') return 'Public url';
      else if (type === 'company_drive') return 'File path company drive';
      return '';
    },

    getDataColumnsByObject() {
      if (this.data_action.object === 'form') {
        if (this.data_action.form.columns) {
          return Object.values(this.data_action.form.columns);
        }
        this.$store.dispatch('jStoreNotificationScreen/toggleInfo', 'Column not available');
      }
      return this.dataColumnDataset;
    },

    actionDescription: {
      get() {
        if (this.data_action && this.data_action.object === 'function') {
          const selectedFunction = this.listFunction.find(i => i.name === this.data_action.function_name);
          return selectedFunction ? selectedFunction.desc : '';
        } else if (this.data_action && this.data_action.object === 'job') {
          const selectedJob = this.listJob.find(i => i.name === this.data_action.job_name);
          return selectedJob ? selectedJob.desc : '';
        } else if (this.data_action && this.data_action.object === 'dedicated_job') {
          const selectedDedicatedJob = this.listDedicatedJob.find(i => i.name === this.data_action.dedicated_job_name);
          return selectedDedicatedJob ? selectedDedicatedJob.desc : '';
        }
        return '';
      },
      set(val) {
        return val;
      },
    },
  },
  watch: {
    // eslint-disable-next-line
    'data_action.object': function (val) {
      if (val === 'file_transfer_ftp') this.getListThirdParty();
    },

    // eslint-disable-next-line
    'data_action.table_group': function (val) {
      if (val) {
        if (this.finishSetDataTableGroup) {
          this.data_action.form = null;
          this.list_field = [];
          this.dataFields = [];
          this.data_action.sorting = { key: null, order: null };
          if (this.dataEdit && this.dataEdit.filter && Object.keys(this.dataEdit.filter).length > 0) {
            this.data_action.conditions = [];
          }
        }

        const reqTable = {
          tablegroup_id: val.id,
          search: '',
        };
        this.getListTableByGroupV2(reqTable).then((res) => {
          if (!res.error) this.tableOptions = res.data || [];
          setTimeout(() => { this.$v.data_action.$reset(); }, 10);
        });
      }
    },

    // eslint-disable-next-line
    'data_action.form': function(data) {
      if (data) {
        this.showBase = false;
        this.list_field = [];

        if (this.dataEdit) {
          if (this.dataEdit.filter) this.data_action.conditions = [];
          this.data_action.variable_name = this.dataEdit.container_variable;

          // Set is disable according to the parent
          const targetBlock = this.dataBlockIsDisable.find(i => i.id === this.id);
          if (targetBlock) this.data_action.is_disable = targetBlock.isDisable || this.dataEdit.is_disable;
        }

        const dataColumns = Object.values(data.columns);
        const dataFields = [];
        let idField = 1;
        this.dataColumnDataset = dataColumns;

        dataColumns.forEach((e) => {
          const dataValue = this.dataEdit && this.dataEdit.data ? (this.dataEdit.data[e.name] ? this.dataEdit.data[e.name] : '') : '';
          dataFields.push({
            attendance_data: null,
            available_list: [],
            available_list_autofilled: false,
            camera_use_type: 0,
            custom_formula: [],
            formula: null,
            group_form_id: '',
            groups: [],
            id: idField,
            is_back_date: false,
            is_can_access_gallery: false,
            is_can_similar: false,
            is_delete: false,
            is_editable: true,
            is_mandatory: false,
            key: '',
            map_type: 1,
            multiple_value: [],
            name: e.name,
            order_id: 1,
            placeholder: '',
            relation_record_form: null,
            relation_record_form_id: 0,
            relation_record_form_name: '',
            source_id: 0,
            type: 'text',
            value: dataValue,
            value_form: null,
          });
          idField++;

          if (this.dataEdit && this.dataEdit.filter && Object.keys(this.dataEdit.filter).length > 0 && !this.finishSetDataTableGroup) {
            this.versionFilter = 'v1';
            if (e.type === 'object' || e.type === '[]object') {
              if (this.dataEdit.filter[`${e.name}.id`]) {
                this.data_action.conditions.push({
                  field: `${e.name}.id`,
                  operator: 'is',
                  value: this.dataEdit.filter[`${e.name}.id`],
                });
              }
              if (this.dataEdit.filter[`${e.name}.name`]) {
                this.data_action.conditions.push({
                  field: `${e.name}.name`,
                  operator: 'is',
                  value: this.dataEdit.filter[`${e.name}.name`],
                });
              }
            } else if (e.type === 'person') {
              if (this.dataEdit.filter[`${e.name}.company_user_id`]) {
                this.data_action.conditions.push({
                  field: `${e.name}.company_user_id`,
                  operator: 'is',
                  value: this.dataEdit.filter[`${e.name}.company_user_id`],
                });
              }
              if (this.dataEdit.filter[`${e.name}.name`]) {
                this.data_action.conditions.push({
                  field: `${e.name}.name`,
                  operator: 'is',
                  value: this.dataEdit.filter[`${e.name}.name`],
                });
              }
              if (this.dataEdit.filter[`${e.name}.email`]) {
                this.data_action.conditions.push({
                  field: `${e.name}.email`,
                  operator: 'is',
                  value: this.dataEdit.filter[`${e.name}.email`],
                });
              }
              if (this.dataEdit.filter[`${e.name}.photo`]) {
                this.data_action.conditions.push({
                  field: `${e.name}.photo`,
                  operator: 'is',
                  value: this.dataEdit.filter[`${e.name}.photo`],
                });
              }
            } else if (e.type === 'timer') {
              if (this.dataEdit.filter[`${e.name}.state`]) {
                this.data_action.conditions.push({
                  field: `${e.name}.state`,
                  operator: 'is',
                  value: this.dataEdit.filter[`${e.name}.state`],
                });
              }
              if (this.dataEdit.filter[`${e.name}.duration`]) {
                this.data_action.conditions.push({
                  field: `${e.name}.duration`,
                  operator: 'is',
                  value: this.dataEdit.filter[`${e.name}.duration`],
                });
              }
            } else if (e.type === 'tags') {
              if (this.dataEdit.filter[`${e.name}.name`]) {
                this.data_action.conditions.push({
                  field: `${e.name}.name`,
                  operator: 'is',
                  value: this.dataEdit.filter[`${e.name}.name`],
                });
              }
              if (this.dataEdit.filter[`${e.name}.background`]) {
                this.data_action.conditions.push({
                  field: `${e.name}.background`,
                  operator: 'is',
                  value: this.dataEdit.filter[`${e.name}.background`],
                });
              }
              if (this.dataEdit.filter[`${e.name}.font_color`]) {
                this.data_action.conditions.push({
                  field: `${e.name}.font_color`,
                  operator: 'is',
                  value: this.dataEdit.filter[`${e.name}.font_color`],
                });
              }
            } else if (this.dataEdit.filter[e.name]) {
              this.data_action.conditions.push({
                field: e.name,
                operator: 'is',
                value: this.dataEdit.filter[e.name],
              });
            }
          }

          if (e.type === 'object' || e.type === '[]object') {
            this.list_field.push({
              id: `${e.name}.id`,
              name: `${e.name}.id`,
            });
            this.list_field.push({
              id: `${e.name}.name`,
              name: `${e.name}.name`,
            });
          } else if (e.type === 'person') {
            this.list_field.push({
              id: `${e.name}.company_user_id`,
              name: `${e.name}.company_user_id`,
            });
            this.list_field.push({
              id: `${e.name}.name`,
              name: `${e.name}.name`,
            });
            this.list_field.push({
              id: `${e.name}.email`,
              name: `${e.name}.email`,
            });
            this.list_field.push({
              id: `${e.name}.photo`,
              name: `${e.name}.photo`,
            });
          } else if (e.type === 'timer') {
            this.list_field.push({
              id: `${e.name}.state`,
              name: `${e.name}.state`,
            });
            this.list_field.push({
              id: `${e.name}.duration`,
              name: `${e.name}.duration`,
            });
          } else if (e.type === 'tags') {
            this.list_field.push({
              id: `${e.name}.name`,
              name: `${e.name}.name`,
            });
            this.list_field.push({
              id: `${e.name}.background`,
              name: `${e.name}.background`,
            });
            this.list_field.push({
              id: `${e.name}.font_color`,
              name: `${e.name}.font_color`,
            });
          } else {
            this.list_field.push({
              id: e.name,
              name: e.name,
            });
          }
        });

        // Set New Filter Conditions
        if (this.dataEdit && this.dataEdit.filter_v2 && this.dataEdit.filter_v2[0] && this.dataEdit.filter_v2[0].and) {
          this.versionFilter = 'v2';
          this.dataEdit.filter_v2[0].and.forEach((f) => {
            const field = String(Object.keys(f));
            const targetedColumn = this.list_field.find(c => c.name === field);
            if (targetedColumn) {
              if (f[field].operator && f[field].operator === 'in') {
                this.data_action.conditions.push({
                  field,
                  operator: f[field].operator,
                  value: f[field].value,
                });
              } else {
                this.data_action.conditions.push({
                  field,
                  operator: f[field].operator,
                  value: f[field].value || null,
                });
              }
            }
          });
        }

        this.dataFields = dataFields;
        setTimeout(() => { this.showBase = true; }, 100);
      }
    },

    // eslint-disable-next-line
    'data_action.joana.group': function(val) {
      if (val) {
        const reqData = {
          page: 1,
          limit: 100,
          filter: {
            where_is_and: { datasetgroup_id: val.id },
          },
          sort: { created_at: -1 },
          filter_operator: 'and',
        };
        this.actionListDatasetByGroup(reqData).then((res) => {
          this.datasetOptions = res.data;
        });
      }
      this.data_action.joana.dataset = null;
      setTimeout(() => {
        this.$v.data_action.$reset();
      }, 100);
    },

    // eslint-disable-next-line
    'data_action.joana.dataset': function(data) {
      if (data) {
        this.getDetailDatasetByGroup({ id: data.id }).then((res) => {
          if (res.data) {
            this.showBase = false;
            if (this.dataEdit) {
              if (this.dataEdit.joana && this.dataEdit.joana.filter) {
                this.data_action.conditions = [];
              }
              this.data_action.variable_name = this.dataEdit.container_variable;
            }

            const dataDetail = res.data;
            if (dataDetail && dataDetail.column) {
              const dataColumns = Object.values(dataDetail.column);
              this.dataColumnDataset = dataColumns;
              this.list_field = [];
              const dataFields = [];
              let idField = 1;
              dataColumns.forEach((e) => {
                let dataValue = '';
                if (this.dataEdit && this.dataEdit.joana) {
                  // eslint-disable-next-line
                  dataValue = this.dataEdit.joana.data ? (this.dataEdit.joana.data[e.name] ? this.dataEdit.joana.data[e.name] : '') : '';
                }
                dataFields.push(
                  {
                    attendance_data: null,
                    available_list: [],
                    available_list_autofilled: false,
                    camera_use_type: 0,
                    custom_formula: [],
                    formula: null,
                    group_form_id: '',
                    groups: [],
                    id: idField,
                    is_back_date: false,
                    is_can_access_gallery: false,
                    is_can_similar: false,
                    is_delete: false,
                    is_editable: true,
                    is_mandatory: false,
                    key: '',
                    map_type: 1,
                    multiple_value: [],
                    name: e.name,
                    order_id: 1,
                    placeholder: '',
                    relation_record_form: null,
                    relation_record_form_id: 0,
                    relation_record_form_name: '',
                    source_id: 0,
                    type: 'text',
                    value: dataValue,
                    value_form: null,
                  },
                );
                // eslint-disable-next-line
                idField++;

                if (this.dataEdit && this.dataEdit.joana && this.dataEdit.joana.filter) {
                  if (this.dataEdit.joana.filter[e.name]) {
                    this.data_action.conditions.push({
                      field: e.name,
                      operator: 'is',
                      value: this.dataEdit.joana.filter[e.name],
                    });
                  }
                }

                this.list_field.push({
                  id: e.name,
                  name: e.name,
                });
              });

              // Set Conditions for Update Big Data
              if (this.dataEdit && this.dataEdit.joana && this.dataEdit.joana.new_filter) {
                if ((this.dataEdit.joana.do === 'update_record' || this.dataEdit.joana.do === 'find_record' || this.dataEdit.joana.do === 'find_records') && this.dataEdit.joana.new_filter[0] && this.dataEdit.joana.new_filter[0].and) {
                  this.dataEdit.joana.new_filter[0].and.forEach((f) => {
                    const field = String(Object.keys(f));
                    const targetedColumn = dataColumns.find(c => c.name === field);
                    if (targetedColumn) {
                      if (f[field].operator && f[field].operator === 'in') {
                        this.data_action.conditions.push({
                          field,
                          operator: f[field].operator,
                          // value: f[field].value.map(i => JSON.stringify(i)).join(','),
                          value: f[field].value,
                        });
                      } else {
                        this.data_action.conditions.push({
                          field,
                          operator: f[field].operator,
                          value: f[field].value || null,
                        });
                      }
                    }
                  });
                }
              }

              this.dataFields = dataFields;
              setTimeout(() => {
                this.showBase = true;
              }, 100);
            }
          }
        });
      }
    },

    // eslint-disable-next-line
    'data_action.variable_name': function (val) {
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.data_action.variable_name = val.replace(regexSymbol, '').replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line
    'data_action.do': function (val) {
      if ((this.data_action.object === 'joana' && (val === 'find_record' || val === 'find_records' || val === 'update_record')) && !this.dataEdit) {
        this.data_action.conditions = [];
      }

      if ((this.data_action.object === 'form' && (val === 'find_record' || val === 'find_records' || val === 'update_record')) && !this.dataEdit) {
        this.data_action.conditions = [];
      }

      if ((this.data_action.object === 'form' && (val === 'find_record' || val === 'find_records' || val === 'update_record')) && !this.dataEdit) {
        this.data_action.conditions = [];
      }
    },

    // eslint-disable-next-line
    'data_action.generate_file.type': function () {
      if (!this.isFirstLoad) {
        this.data_action.generate_file.file_name = null;
        this.data_action.generate_file.extension = null;
        this.data_action.generate_file.data_type = null;
        this.data_action.generate_file.header = null;
        this.data_action.generate_file.data = null;
        this.data_action.generate_file.delimiter = null;
        this.data_action.generate_file.path = null;
        this.data_action.generate_file.encryption = {
          active: false,
          algorithm: 'aes256',
          cipher_mode: null,
          output_text_format: null,
          initial_vector: null,
          secret_key: null,
        };
        this.data_action.delimiterSelected = null;
      }
    },

    // eslint-disable-next-line
    'data_action.generate_file.encryption.active': function () {
      if (!this.data_action.generate_file.encryption.active) {
        this.data_action.generate_file.encryption.algorithm = 'aes256';
        this.data_action.generate_file.encryption.cipher_mode = null;
        this.data_action.generate_file.encryption.output_text_format = null;
        this.data_action.generate_file.encryption.initial_vector = null;
        this.data_action.generate_file.encryption.secret_key = null;
      }
    },

    // eslint-disable-next-line
    'data_action.delimiterSelected': function (val) {
      if (!this.isFirstLoad) {
        if (this.data_action.object === 'generate_file') {
          if (val === 'other') this.data_action.generate_file.delimiter = '';
          else this.data_action.generate_file.delimiter = val;
        } else if (this.data_action.object === 'file_transfer_ftp') {
          if (val === 'other') this.data_action.file_transfer_ftp.delimiter = '';
          else this.data_action.file_transfer_ftp.delimiter = val;
        }
      }
    },

    // eslint-disable-next-line
    'data_action.file_transfer_ftp.do': function () {
      if (!this.isFirstLoad) {
        this.data_action.file_transfer_ftp.third_party_connection = null;
        this.data_action.file_transfer_ftp.source_file = null;
        this.data_action.file_transfer_ftp.source_path = null;
        this.data_action.file_transfer_ftp.ftp_source_file_path = null;
        this.data_action.file_transfer_ftp.destination_path = null;
        this.data_action.file_transfer_ftp.ftp_destination_folder = null;
        this.data_action.file_transfer_ftp.backup_to_company_drive = null;
        this.data_action.file_transfer_ftp.extension = null;
        this.data_action.file_transfer_ftp.compress = null;
        this.data_action.file_transfer_ftp.delimiter = null;
      }
    },

    dataEdit() {
      this.setValueOnProperties();

      // Set disable block according to parent
      this.updateIsDisableBlock();
    },

    propertiesOpened(val) {
      if (!val) this.blockActive = false;
    },

    list_connection(val) {
      const connection = val.filter(con => con.type === 'ftp' || con.type === 'sftp');
      this.listThirdParty = connection.map(el => ({
        id: el.id,
        id_hash: el.id,
        label: el.connection_name,
      }));
    },

    // eslint-disable-next-line func-names
    'data_action.is_disable': function (val) {
      this.disable_block = !val;
    },

    disable_block(val) {
      this.data_action.is_disable = !val;
    },
  },
  created() {
    this.setValueOnProperties();

    if (this.onProperties) {
      this.getListFunction();
      this.getListJob();
      this.getListDedicatedJob();
      this.getListGroupTable();
      this.getListConnectivity();

      if (process.env.BIG_DATA_ENGINE_MENU === 'true') this.getListGroupDataset();
    }
  },
  mounted() {
    // Set disable block according to parent
    this.updateIsDisableBlock();
  },
  methods: {
    ...mapActions('jStoreAutomation', ['findForm', 'getDetailAutomation']),
    ...mapActions('jStoreDataConnectivity', ['findDataConnectivity']),
    ...mapActions('jStoreJoana', ['getDetailDatasetByGroup', 'listQuery', 'getListDataGroup', 'actionListDatasetByGroup']),
    ...mapActions('jStoreForm', ['getListDataGroupByCompanyId', 'getListTableByGroupV2']),
    ...mapMutations('jStoreAutomation', ['setPropertiesOpened']),
    ...mapActions('jStoreThirdParty', ['getListThirdPartyConnection', 'detailThirdPartyConnection']),

    setValueOnProperties() {
      this.blockError = false;
      this.disable_block = !this.data_action.is_disable;
      if (this.dataEdit) {
        switch (this.dataEdit.type) {
          case 'external_api':
            this.data_action.object = 'call_webhook';
            break;
          case 'send_email':
            this.data_action.object = 'send_notification';
            break;
          case 'send_notification':
            this.data_action.object = 'send_notification';
            break;
          case 'data_connectivity':
            this.data_action.object = 'data_connectivity';
            break;
          case 'function':
            this.data_action.object = 'function';
            break;
          case 'job':
            this.data_action.object = 'job';
            break;
          case 'dedicated_job':
            this.data_action.object = 'dedicated_job';
            break;
          case 'joana':
            this.data_action.object = 'joana';
            break;
          case 'generate_file_csv':
            this.data_action.object = 'generate_file';
            break;
          case 'generate_file_text':
            this.data_action.object = 'generate_file';
            break;
          case 'ftp_read_single_file':
            this.data_action.object = 'file_transfer_ftp';
            break;
          case 'ftp_get_list_directory':
            this.data_action.object = 'file_transfer_ftp';
            break;
          case 'ftp_download_single_file':
            this.data_action.object = 'file_transfer_ftp';
            break;
          case 'ftp_upload':
            this.data_action.object = 'file_transfer_ftp';
            break;
          case 'ftp_move_single_file':
            this.data_action.object = 'file_transfer_ftp';
            break;
          case 'ftp_delete_single_file':
            this.data_action.object = 'file_transfer_ftp';
            break;
          case 'compress_file_base64':
            this.data_action.object = 'compress_file';
            break;
          case 'compress_file_multiple_url':
            this.data_action.object = 'compress_file';
            break;
          case 'compress_file_company_drive':
            this.data_action.object = 'compress_file';
            break;
          default :
            this.data_action.object = 'form';
        }

        if (this.dataEdit.type === 'external_api') {
          this.data_action.url = this.dataEdit.external_api.url;
          this.data_action.method = this.dataEdit.external_api.method;
          this.data_action.body = this.dataEdit.external_api.body;
          this.data_action.variable_name = this.dataEdit.container_variable;
          this.data_action.is_disable_log = this.dataEdit.is_disable_log || false;
          this.data_action.is_async = this.dataEdit.is_async || false;
          this.data_action.is_disable = this.dataEdit.is_disable || false;

          const listColumns = Object.keys(this.dataEdit.external_api.header);
          const listColumnsVal = Object.values(this.dataEdit.external_api.header);

          if (listColumns.length > 0) {
            this.data_action.column = [];
            listColumns.forEach((column, index) => {
              this.data_action.column.push({
                name: column,
                value: listColumnsVal[index],
              });
            });
          }
          this.showContainer = true;
        } else if (this.dataEdit.type === 'send_email') {
          this.data_action.to_email = this.dataEdit.data.to;
          this.data_action.cc = this.dataEdit.data.cc;
          this.data_action.bcc = this.dataEdit.data.bcc;
          this.data_action.subject = this.dataEdit.data.subject;
          this.data_action.message = this.deadjustHtml(this.dataEdit.data.message);
          this.data_action.type = this.dataEdit.type;
          this.data_action.variable_name = this.dataEdit.container_variable;
          this.data_action.is_disable = this.dataEdit.is_disable || false;
          this.showContainer = true;
        } else if (this.dataEdit.type === 'send_notification') {
          this.data_action.push_notif_to = this.dataEdit.send_notification.user_company_ids;
          this.data_action.push_notif_heading = this.dataEdit.send_notification.heading;
          this.data_action.push_notif_content = this.dataEdit.send_notification.content;
          this.data_action.is_custom_redirect = this.dataEdit.send_notification.is_custom_redirect;
          this.data_action.script_redirect = this.dataEdit.send_notification.script_redirect;
          this.data_action.variable_redirect = this.dataEdit.send_notification.variable_redirect;
          this.data_action.type = this.dataEdit.type;
          this.data_action.variable_name = this.dataEdit.container_variable;
          this.data_action.is_disable = this.dataEdit.is_disable || false;
          this.showContainer = true;
        } else if (this.dataEdit.type === 'data_connectivity') {
          this.data_action.query = this.dataEdit.data_connection.query;
          this.data_action.do_jdc = this.dataEdit.data_connection.do;
          this.data_action.type = 'data_connectivity';
          this.data_action.object = 'data_connectivity';
          this.data_action.variable_name = this.dataEdit.container_variable;
          this.data_action.is_disable_log = this.dataEdit.is_disable_log || false;
          this.data_action.is_async = this.dataEdit.is_async || false;
          this.data_action.is_disable = this.dataEdit.is_disable || false;

          const dataFilter = {
            id: this.dataEdit.data_connection.connection,
          };
          const reqData = {
            limit: 1,
            page: 1,
            filter: JSON.stringify(dataFilter),
          };
          this.findDataConnectivity(reqData).then((param) => {
            this.showContainer = true;
            const dataJDC = param.data.data[0];
            dataJDC.label = dataJDC.connection_name;
            dataJDC.text = dataJDC.connection_name;
            this.data_action.connection = dataJDC;
            if (this.data_action.connection) {
              jApiDataConnectivity.verifyDataConnectivity(dataJDC).then((resp) => { this.dataConnectionDescription = resp.data.join(', '); });
            }
          });
        } else if (this.dataEdit.type === 'function') {
          this.data_action.function_name = this.dataEdit.function ? this.dataEdit.function.name : null;
          this.data_action.input = this.dataEdit.function ? this.dataEdit.function.input : '';
          this.data_action.variable_name = this.dataEdit.container_variable;
          this.data_action.is_disable_log = this.dataEdit.is_disable_log || false;
          this.data_action.is_async = this.dataEdit.is_async || false;
          this.data_action.is_disable = this.dataEdit.is_disable || false;
          this.showContainer = true;
        } else if (this.dataEdit.type === 'job') {
          this.data_action.job_name = this.dataEdit.job ? this.dataEdit.job.name : null;
          this.data_action.input = this.dataEdit.job ? this.dataEdit.job.input : '';
          this.data_action.is_disable = this.dataEdit.is_disable || false;
          this.showContainer = true;
        } else if (this.dataEdit.type === 'dedicated_job') {
          this.data_action.dedicated_job_name = this.dataEdit.dedicated_job ? this.dataEdit.dedicated_job.name : null;
          this.data_action.input = this.dataEdit.dedicated_job ? this.dataEdit.dedicated_job.input : '';
          this.data_action.is_disable = this.dataEdit.is_disable || false;
          this.showContainer = true;
        } else if (this.dataEdit.type === 'joana') {
          this.data_action.do = this.dataEdit.joana ? this.dataEdit.joana.do : null;
          this.data_action.variable_name = this.dataEdit.container_variable;
          this.data_action.is_disable_log = this.dataEdit.is_disable_log || false;
          this.data_action.is_disable = this.dataEdit.is_disable || false;
          this.data_action.page = this.dataEdit.joana ? this.dataEdit.joana.page : null;
          this.data_action.limit = this.dataEdit.joana ? this.dataEdit.joana.limit : null;
          this.data_action.input = this.dataEdit.joana ? this.dataEdit.joana.input : '';
          this.dataQuery = this.dataEdit.joana ? this.dataEdit.joana.query : '\n\n\n\n\n\n';
          this.query_type = this.dataEdit.joana ? this.dataEdit.joana.query_type : '';

          if (this.dataEdit.joana) {
            this.data_action.joana.group = {
              id: this.dataEdit.joana.dataset_group_id,
              name: this.dataEdit.joana.dataset_group_name,
              label: this.dataEdit.joana.dataset_group_name,
            };

            setTimeout(() => {
              this.data_action.joana.dataset = {
                id: this.dataEdit.joana.dataset_id,
                name: this.dataEdit.joana.dataset_name,
                label: this.dataEdit.joana.dataset_name,
              };
            }, 500);
          }

          if (this.dataEdit.joana && this.dataEdit.joana.sort) {
            const keySort = Object.keys(this.dataEdit.joana.sort);
            const valueSort = Object.values(this.dataEdit.joana.sort);

            if (keySort.length > 0) {
              this.data_action.sorting = {
                key: { id: keySort[0] },
                order: valueSort[0] === 1 ? { id: 'asc' } : { id: 'desc' },
              };
            }
          }
          this.showContainer = true;
        } else if (this.dataEdit.type === 'generate_file_csv') {
          const generateFile = this.dataEdit.generate_file_csv;
          if (generateFile) {
            this.data_action.generate_file.type = 'csv';
            this.data_action.generate_file.extension = generateFile.extension;
            this.data_action.generate_file.file_name = generateFile.file_name;
            this.data_action.generate_file.data_type = generateFile.data_type;
            this.data_action.generate_file.header = generateFile.header;
            this.data_action.generate_file.data = generateFile.data;
            this.data_action.generate_file.delimiter = generateFile.delimiter;
            this.data_action.generate_file.path = generateFile.path;
            this.data_action.generate_file.encryption = {
              active: generateFile.encryption ? generateFile.encryption.active : false,
              algorithm: generateFile.encryption ? (generateFile.encryption.algorithm || 'aes256') : 'aes256',
              cipher_mode: generateFile.encryption ? generateFile.encryption.cipher_mode : null,
              output_text_format: generateFile.encryption ? generateFile.encryption.output_text_format : null,
              initial_vector: generateFile.encryption ? generateFile.encryption.initial_vector : null,
              secret_key: generateFile.encryption ? generateFile.encryption.secret_key : null,
            };

            if (generateFile.delimiter) {
              const checkDelimiter = this.delimiterOptions.some(d => d.id === generateFile.delimiter);
              if (checkDelimiter) this.data_action.delimiterSelected = generateFile.delimiter;
              else this.data_action.delimiterSelected = 'other';
            }
          }
          this.data_action.variable_name = this.dataEdit.container_variable;
          this.data_action.is_disable_log = this.dataEdit.is_disable_log || false;
          this.data_action.is_async = this.dataEdit.is_async || false;
          this.data_action.is_disable = this.dataEdit.is_disable || false;
          this.showContainer = true;
        } else if (this.dataEdit.type === 'generate_file_text') {
          const generateFile = this.dataEdit.generate_file_text;
          if (generateFile) {
            this.data_action.generate_file.type = 'txt';
            this.data_action.generate_file.extension = generateFile.extension;
            this.data_action.generate_file.file_name = generateFile.file_name;
            this.data_action.generate_file.header = generateFile.header;
            this.data_action.generate_file.data = generateFile.data;
            this.data_action.generate_file.path = generateFile.path;
          }
          this.data_action.variable_name = this.dataEdit.container_variable;
          this.data_action.is_disable_log = this.dataEdit.is_disable_log || false;
          this.data_action.is_async = this.dataEdit.is_async || false;
          this.data_action.is_disable = this.dataEdit.is_disable || false;
          this.showContainer = true;
        } else if (this.dataEdit.type.includes('ftp_')) {
          const fileTransfer = this.dataEdit[this.dataEdit.type];
          if (fileTransfer) {
            this.data_action.file_transfer_ftp.do = this.dataEdit.type;
            this.data_action.file_transfer_ftp.third_party_connection = fileTransfer.third_party_connection;
            this.data_action.file_transfer_ftp.source_file = fileTransfer.source_file;
            this.data_action.file_transfer_ftp.source_path = fileTransfer.source_path;
            this.data_action.file_transfer_ftp.ftp_source_file_path = fileTransfer.ftp_source_file_path;
            this.data_action.file_transfer_ftp.destination_path = fileTransfer.destination_path;
            this.data_action.file_transfer_ftp.ftp_destination_folder = fileTransfer.ftp_destination_folder;
            this.data_action.file_transfer_ftp.extension = fileTransfer.extension;

            if (this.dataEdit.type === 'ftp_upload' || this.dataEdit.type === 'ftp_read_single_file') {
              this.data_action.file_transfer_ftp.delimiter = fileTransfer.delimiter;
              this.data_action.file_transfer_ftp.compress = '';
            }

            if (this.dataEdit.type === 'ftp_delete_single_file') {
              this.data_action.file_transfer_ftp.backup_to_company_drive = fileTransfer.backup_to_company_drive || false;
            }

            if (fileTransfer.delimiter) {
              const checkDelimiter = this.delimiterOptions.some(d => d.id === fileTransfer.delimiter);
              if (checkDelimiter) this.data_action.delimiterSelected = fileTransfer.delimiter;
              else this.data_action.delimiterSelected = 'other';
            }
          }
          this.data_action.variable_name = this.dataEdit.container_variable;
          this.data_action.is_disable_log = this.dataEdit.is_disable_log || false;
          this.data_action.is_async = this.dataEdit.is_async || false;
          this.data_action.is_disable = this.dataEdit.is_disable || false;
          this.showContainer = true;
        } else if (this.dataEdit.type.includes('compress_file_')) {
          const compressFile = this.dataEdit[this.dataEdit.type];
          if (compressFile) {
            const dataDo = this.dataEdit.type.replace('compress_file_', '');
            if (dataDo === 'base64') this.data_action.compress_file.dataBase64 = compressFile.data;
            else if (dataDo === 'multiple_url') this.data_action.compress_file.dataPublicUrl = compressFile.data;
            else if (dataDo === 'company_drive') this.data_action.compress_file.dataCompanyDrive = compressFile.data;
            this.data_action.compress_file.name = compressFile.name;
            this.data_action.compress_file.compress_type = compressFile.compress_type;
            this.data_action.compress_file.password = compressFile.password;
            this.data_action.compress_file.destination_folder = compressFile.destination_folder;
            this.data_action.compress_file.do = dataDo;
            this.data_action.variable_name = this.dataEdit.container_variable;
            this.data_action.is_disable_log = this.dataEdit.is_disable_log || false;
            this.data_action.is_async = this.dataEdit.is_async || false;
            this.data_action.is_disable = this.dataEdit.is_disable || false;
            this.showContainer = true;
          }
        } else {
          const reqData = {
            form_data_id: this.dataEdit.form_data_id,
          };
          this.findForm(reqData).then((res) => {
            this.finishSetDataTableGroup = false;
            const dataForm = res.data;
            dataForm.label = dataForm.name;

            this.data_action.form = dataForm;
            this.data_action.do = this.dataEdit.type;
            this.data_action.variable_name = this.dataEdit.container_variable;
            this.data_action.page = this.dataEdit.page;
            this.data_action.limit = this.dataEdit.limit;
            this.data_action.is_disable_log = this.dataEdit.is_disable_log || false;
            this.data_action.is_async = this.dataEdit.is_async || false;
            this.data_action.is_disable = this.dataEdit.is_disable || false;
            this.data_action.is_disable_audit_trail = this.dataEdit.form_data ? this.dataEdit.form_data.is_disable_audit_trail : false;
            this.data_action.input = this.dataEdit.form_data ? this.dataEdit.form_data.input : '';

            if (this.dataEdit.sort) {
              const keySort = Object.keys(this.dataEdit.sort);
              const valueSort = Object.values(this.dataEdit.sort);

              if (keySort.length > 0) {
                this.data_action.sorting = {
                  key: { id: keySort[0] },
                  order: valueSort[0] === 1 ? { id: 'asc' } : { id: 'desc' },
                };
              }
            }
            this.showContainer = true;

            if (this.tableGroupOptions.length > 0) {
              const findTableGroup = this.tableGroupOptions.find(f => f.id === this.dataEdit.tablegroup_id);
              this.data_action.table_group = findTableGroup || null;

              if (!findTableGroup && this.data_action.form) {
                if (this.data_action.form.tablegroup_id) {
                  const findTableGroupExist = this.tableGroupOptions.find(f => f.id === this.data_action.form.tablegroup_id);
                  this.data_action.table_group = findTableGroupExist || null;
                } else {
                  const findTableGroupLegacy = this.tableGroupOptions.find(f => f.id === 'legacy');
                  this.data_action.table_group = findTableGroupLegacy;
                }
              } else if (!findTableGroup && !this.data_action.form) {
                const findTableGroupLegacy = this.tableGroupOptions.find(f => f.id === 'legacy');
                this.data_action.table_group = findTableGroupLegacy;
              }
            }
            setTimeout(() => { this.finishSetDataTableGroup = true; }, 1000);
          });
        }

        setTimeout(() => {
          this.isFirstLoad = false;
        }, 500);
      } else {
        let doActonFromSelectedList = '';
        if (this.dataDoAction && this.dataDoAction.type === 'Data Manager') {
          doActonFromSelectedList = this.doOptions.find(f => f.text === this.dataDoAction.do);
          this.data_action.object = 'form';
          this.data_action.do = doActonFromSelectedList && doActonFromSelectedList.id ? doActonFromSelectedList.id : null;
        }
        if (this.dataDoAction && this.dataDoAction.type === 'Big Data Engine') {
          doActonFromSelectedList = this.doOptionsJoana.find(f => f.text === this.dataDoAction.do);
          this.data_action.object = 'joana';
          this.data_action.do = doActonFromSelectedList && doActonFromSelectedList.id ? doActonFromSelectedList.id : null;
        }
        if (this.dataDoAction && this.dataDoAction.type === 'Data Connectivity') {
          doActonFromSelectedList = this.doOptionsDataConnectivity.find(f => f.text === this.dataDoAction.do);
          this.data_action.object = 'data_connectivity';
          this.data_action.do_jdc = doActonFromSelectedList && doActonFromSelectedList.id ? doActonFromSelectedList.id : null;
        }
        if (this.dataDoAction && this.dataDoAction.type === 'File Transfer') {
          doActonFromSelectedList = this.doOptionsFileTransfer.find(f => f.text === this.dataDoAction.do);
          this.data_action.object = 'file_transfer_ftp';
          this.data_action.file_transfer_ftp.do = doActonFromSelectedList && doActonFromSelectedList.id ? doActonFromSelectedList.id : null;
        }
        if (this.dataDoAction && this.dataDoAction.type === 'Function') {
          this.data_action.object = 'function';
        }
        if (this.dataDoAction && this.dataDoAction.type === 'API') {
          this.data_action.object = 'call_webhook';
        }
        if (this.dataDoAction && this.dataDoAction.type === 'Job') {
          this.data_action.object = 'job';
        }
        if (this.dataDoAction && this.dataDoAction.type === 'Dedicated Job') {
          this.data_action.object = 'dedicated_job';
        }
        if (this.dataDoAction && this.dataDoAction.type === 'Generate File') {
          this.data_action.object = 'generate_file';
        }
        if (this.dataDoAction && this.dataDoAction.type === 'Send Notification') {
          doActonFromSelectedList = this.typeNotifOptions.find(f => f.text === this.dataDoAction.do);
          this.data_action.object = 'send_notification';
          this.data_action.type = doActonFromSelectedList && doActonFromSelectedList.id ? doActonFromSelectedList.id : null;
        }
        this.isFirstLoad = false;
      }
    },

    getListFunction(name) {
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      dataFilter['trigger.type'] = 'function';
      const param = {
        limit: 1000000,
        page: 1,
        sort: { created_at: -1 },
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((res) => {
        this.listFunction = res.data.data.map(e => ({
          id: e.trigger.function ? e.trigger.function.name : '',
          name: e.trigger.function ? e.trigger.function.name : '',
          desc: e.description,
        }));

        if (name && res.data.data.length > 0) {
          const findVP = res.data.data.find(f => f.trigger.function.name === name);
          if (findVP) {
            const url = window.location.href;
            const slashPosition = url.lastIndexOf('/') + 1;
            const idReplaced = url.substring(slashPosition);
            const targetUrl = url.replace(String(idReplaced), findVP.id);
            window.open(targetUrl, '_blank');
          } else {
            this.$store.dispatch('jStoreNotificationScreen/toggleInfo', 'Automation not found');
          }
        }
      });
    },

    getListJob(name) {
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      dataFilter['trigger.type'] = 'job';
      const param = {
        limit: 1000000,
        page: 1,
        sort: { created_at: -1 },
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((res) => {
        this.listJob = res.data.data.map(e => ({
          id: e.trigger.job ? e.trigger.job.name : '',
          name: e.trigger.job ? e.trigger.job.name : '',
          desc: e.description,
        }));

        if (name && res.data.data.length > 0) {
          const findVP = res.data.data.find(f => f.trigger.job.name === name);
          if (findVP) {
            const url = window.location.href;
            const slashPosition = url.lastIndexOf('/') + 1;
            const idReplaced = url.substring(slashPosition);
            const targetUrl = url.replace(String(idReplaced), findVP.id);
            window.open(targetUrl, '_blank');
          } else {
            this.$store.dispatch('jStoreNotificationScreen/toggleInfo', 'Automation not found');
          }
        }
      });
    },

    getListDedicatedJob(name) {
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      dataFilter['trigger.type'] = 'dedicated_job';
      const param = {
        limit: 1000000,
        page: 1,
        sort: { created_at: -1 },
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((res) => {
        this.listDedicatedJob = res.data.data.map(e => ({
          id: e.trigger.dedicated_job ? e.trigger.dedicated_job.name : '',
          name: e.trigger.dedicated_job ? e.trigger.dedicated_job.name : '',
          desc: e.description,
        }));

        if (name && res.data.data.length > 0) {
          const findVP = res.data.data.find(f => f.trigger.dedicated_job.name === name);
          if (findVP) {
            const url = window.location.href;
            const slashPosition = url.lastIndexOf('/') + 1;
            const idReplaced = url.substring(slashPosition);
            const targetUrl = url.replace(String(idReplaced), findVP.id);
            window.open(targetUrl, '_blank');
          } else {
            this.$store.dispatch('jStoreNotificationScreen/toggleInfo', 'Automation not found');
          }
        }
      });
    },

    getListGroupTable() {
      this.getListDataGroupByCompanyId().then((res) => {
        if (!res.error) {
          this.tableGroupOptions = res.data || [];
          this.finishSetDataTableGroup = false;

          if (this.dataEdit && this.dataEdit.form_data_id) {
            const findTableGroup = res.data.find(f => f.id === this.dataEdit.tablegroup_id);
            this.data_action.table_group = findTableGroup || null;

            if (!findTableGroup && this.data_action.form) {
              if (this.data_action.form.tablegroup_id) {
                const findTableGroupExist = res.data.find(f => f.id === this.data_action.form.tablegroup_id);
                this.data_action.table_group = findTableGroupExist || null;
              } else {
                const findTableGroupLegacy = res.data.find(f => f.id === 'legacy');
                this.data_action.table_group = findTableGroupLegacy;
              }
            } else if (!findTableGroup && !this.data_action.form) {
              const findTableGroupLegacy = res.data.find(f => f.id === 'legacy');
              this.data_action.table_group = findTableGroupLegacy;
            }
          }
          setTimeout(() => { this.finishSetDataTableGroup = true; }, 1000);
        }
      });
    },

    getListConnectivity() {
      jApiDataConnectivity.getListDataConnectivity({ limit: 1000 }).then((data) => {
        this.loadOptionsDataConnectivity = data.data.data.map((v) => {
          const x = v;
          x.label = v.connection_name;
          x.text = v.connection_name;
          return x;
        });
      });
    },

    async getListThirdParty() {
      const params = {
        limit: 50,
        page: 1,
        sort: { created_at: -1 },
      };
      await this.getListThirdPartyConnection(params);
    },

    async onChangeThirdPartyConnection(thirdParty) {
      const res = await this.detailThirdPartyConnection({ id: thirdParty.id_hash }, false);
      if (!res.error) {
        this.detailThirdParty = res.data.config;
      }
    },

    highlighter(code) {
      return highlight(code, languages.js); // returns html
    },

    popOverJDCHandler() {
      this.popOverJDCShow = !this.popOverJDCShow;
    },

    onChangeConnectionJDC(val) {
      if (val) {
        jApiDataConnectivity.verifyDataConnectivity(val).then((resp) => { this.dataConnectionDescription = resp.data.join(', '); });
      }
    },

    addConditions() {
      this.data_action.conditions.push({
        field: null,
        operator: null,
        value: '',
      });
    },

    deleteConditions(index) {
      this.data_action.conditions.splice(index, 1);
    },

    validateData() {
      this.$v.data_action.$touch();
      return this.$v.data_action.$error;
    },

    getData() {
      return new Promise((resolve, reject) => {
        if (!this.validateData() && this.data_action.object === 'form') {
          const data = {
            type: this.data_action.do,
            form_data_id: this.data_action.form.id,
            tablegroup_id: this.data_action.table_group.id,
            form_data_id_reference: '',
            data: {},
            container_variable: this.data_action.variable_name,
            filter: {},
            sort: {},
            page: 0,
            limit: 0,
          };
          if (this.data_action.do === 'create_record' || this.data_action.do === 'update_record') {
            this.$refs.jFormCreate.getData().then((params) => {
              const dataColumns = Object.values(this.data_action.form.columns);
              dataColumns.forEach((e) => {
                const findValue = params.find(f => f.name === e.name);
                data.data[e.name] = findValue.value ? findValue.value : '';
              });
            });
          }
          if (this.data_action.do === 'delete_record' ||
            (this.versionFilter === 'v1' && (this.data_action.do === 'find_record' || this.data_action.do === 'find_records' || this.data_action.do === 'update_record'))
          ) {
            this.data_action.conditions.forEach((e) => {
              if (e.field) data.filter[e.field] = e.value;
            });
          }
          if (this.versionFilter === 'v2' && (this.data_action.do === 'find_record' || this.data_action.do === 'find_records' || this.data_action.do === 'update_record')) {
            const filter = [];
            this.data_action.conditions.forEach((e) => {
              if (e.operator === 'is_not_null' || e.operator === 'is_null') {
                filter.push({
                  [e.field]: {
                    operator: e.operator,
                  },
                });
              } else {
                filter.push({
                  [e.field]: {
                    operator: e.operator,
                    value: e.value,
                  },
                });
              }
            });
            data.filter_v2 = (filter && filter.length > 0) ? [{ and: filter }] : null;
          }
          if (this.data_action.do === 'find_records') {
            data.page = this.data_action.page || 0;
            data.limit = this.data_action.limit || 0;
            if (this.data_action.sorting.key && this.data_action.sorting.order) {
              data.sort = {
                [this.data_action.sorting.key.id]: this.data_action.sorting.order.id === 'asc' ? 1 : -1,
              };
            }
          }
          if (this.data_action.do === 'find_record' ||
            this.data_action.do === 'find_records' ||
            this.data_action.do === 'update_record' ||
            this.data_action.do === 'delete_record' ||
            this.data_action.do === 'create_record' ||
            this.data_action.do === 'create_records') {
            data.is_disable_log = this.data_action.is_disable_log;
            data.is_async = this.data_action.is_async;
            data.is_disable = this.data_action.is_disable;
          }
          if (this.data_action.do === 'create_record' || this.data_action.do === 'create_records') {
            data.form_data = {
              is_disable_audit_trail: this.data_action.is_disable_audit_trail,
              input: this.data_action.input,
            };
          }
          if (this.dataEdit && this.dataEdit.id) {
            data.id = this.dataEdit.id;
          }
          resolve(data);
        } else if (!this.validateData() && this.data_action.object === 'call_webhook') {
          const data = {
            type: 'external_api',
            external_api: {
              url: this.data_action.url,
              method: this.data_action.method,
              body: this.data_action.body,
              header: {},
            },
            is_disable_log: this.data_action.is_disable_log,
            container_variable: this.data_action.variable_name,
            is_async: this.data_action.is_async,
            is_disable: this.data_action.is_disable,
          };
          this.data_action.column.forEach((e) => {
            data.external_api.header[e.name] = e.value;
          });
          if (this.dataEdit && this.dataEdit.id) {
            data.id = this.dataEdit.id;
          }
          resolve(data);
        } else if (!this.validateData() && this.data_action.object === 'send_notification') {
          const data = {
            type: this.data_action.type === 'send_email' ? 'send_email' : 'send_notification',
            container_variable: this.data_action.variable_name,
            is_disable: this.data_action.is_disable,
          };
          if (this.data_action.type === 'send_email') {
            data.data = {
              to: this.data_action.to_email,
              cc: this.data_action.cc,
              bcc: this.data_action.bcc,
              subject: this.data_action.subject,
              message: this.adjustHtml(this.data_action.message),
            };
          }
          if (this.data_action.type === 'send_notification') {
            data.send_notification = {
              user_company_ids: this.data_action.push_notif_to,
              content: this.data_action.push_notif_content,
              heading: this.data_action.push_notif_heading,
              is_custom_redirect: this.data_action.is_custom_redirect,
              script_redirect: this.data_action.is_custom_redirect ? this.$refs.scriptEditor.getData() :
                (this.dataEdit ? this.dataEdit.send_notification.script_redirect : ''),
              variable_redirect: this.data_action.variable_redirect,
            };
          }
          if (this.dataEdit && this.dataEdit.id) {
            data.id = this.dataEdit.id;
          }
          resolve(data);
        } else if (!this.validateData() && this.data_action.object === 'data_connectivity') {
          this.data_action.object = 'data_connectivity';
          this.data_action.type = 'data_connectivity';
          const data = {
            type: 'data_connectivity',
            container_variable: this.data_action.variable_name,
            is_disable_log: this.data_action.is_disable_log,
            is_async: this.data_action.is_async,
            data_connection: {
              query: this.data_action.query,
              connection: this.data_action.connection.id,
              do: this.data_action.do_jdc,
            },
            is_disable: this.data_action.is_disable,
          };
          if (this.dataEdit && this.dataEdit.id) {
            data.id = this.dataEdit.id;
          }
          resolve(data);
        } else if (!this.validateData() && this.data_action.object === 'function') {
          const data = {
            type: 'function',
            function: {
              name: this.data_action.function_name,
              input: this.data_action.input,
            },
            is_disable_log: this.data_action.is_disable_log,
            is_async: this.data_action.is_async,
            container_variable: this.data_action.variable_name,
            is_disable: this.data_action.is_disable,
          };
          if (this.dataEdit && this.dataEdit.id) {
            data.id = this.dataEdit.id;
          }
          resolve(data);
        } else if (!this.validateData() && this.data_action.object === 'job') {
          const data = {
            type: 'job',
            job: {
              name: this.data_action.job_name,
              input: this.data_action.input,
            },
            is_disable: this.data_action.is_disable,
          };
          if (this.dataEdit && this.dataEdit.id) {
            data.id = this.dataEdit.id;
          }
          resolve(data);
        } else if (!this.validateData() && this.data_action.object === 'dedicated_job') {
          const data = {
            type: 'dedicated_job',
            dedicated_job: {
              name: this.data_action.dedicated_job_name,
              input: this.data_action.input,
            },
            is_disable: this.data_action.is_disable,
          };
          if (this.dataEdit && this.dataEdit.id) {
            data.id = this.dataEdit.id;
          }
          resolve(data);
        } else if (!this.validateData() && this.data_action.object === 'joana') {
          const data = {
            type: 'joana',
            container_variable: this.data_action.variable_name,
            is_disable_log: this.data_action.is_disable_log,
            is_disable: this.data_action.is_disable,
            joana: {
              dataset_group_id: this.data_action.joana.group.id,
              dataset_group_name: this.data_action.joana.group.name,
              dataset_id: this.data_action.joana.dataset.id,
              dataset_name: this.data_action.joana.dataset.name,
              do: this.data_action.do,
              data: {},
              filter: {},
              new_filter: [],
              sort: {},
              page: '',
              limit: '',
              query: '',
              query_type: '',
              input: '',
            },
          };
          if (this.data_action.do === 'create_record' || this.data_action.do === 'update_record') {
            this.$refs.jFormCreate.getData().then((params) => {
              this.dataColumnDataset.forEach((e) => {
                const findValue = params.find(f => f.name === e.name);
                if (this.data_action.do === 'update_record' && findValue.value) {
                  data.joana.data[e.name] = findValue.value;
                }
                if (this.data_action.do === 'create_record') {
                  data.joana.data[e.name] = findValue.value ? findValue.value : '';
                }
              });
            });
          }
          if (this.data_action.do === 'update_record' || this.data_action.do === 'find_record' || this.data_action.do === 'find_records') {
            if (this.data_action.conditions && this.data_action.conditions.length === 0) {
              data.joana.new_filter = null;
            } else {
              const filter = [];
              this.data_action.conditions.forEach((e) => {
                if (e.operator === 'is_not_null' || e.operator === 'is_null') {
                  filter.push({
                    [e.field]: {
                      operator: e.operator,
                    },
                  });
                } else if (e.operator === 'in') {
                  // const formatedValue = e.value.split(',').map(i => i.replace(/(^["']|["']$)/g, ''));
                  filter.push({
                    [e.field]: {
                      operator: e.operator,
                      value: e.value,
                    },
                  });
                } else {
                  filter.push({
                    [e.field]: {
                      operator: e.operator,
                      value: e.value,
                    },
                  });
                }
              });
              data.joana.new_filter = [{
                and: filter,
              }];
            }
          }
          if (this.data_action.do === 'find_records') {
            data.joana.page = this.data_action.page || 0;
            data.joana.limit = this.data_action.limit || 0;
            if (this.data_action.sorting.key && this.data_action.sorting.order) {
              data.joana.sort = {
                [this.data_action.sorting.key.id]: this.data_action.sorting.order.id === 'asc' ? 1 : -1,
              };
            }
          }
          if (this.data_action.do === 'execute_query') {
            const query = typeof this.$refs.queryEditor !== 'undefined' ? this.$refs.queryEditor.getData().trim() : '';

            // const query = this.dataQuery.trim();
            // eslint-disable-next-line
            // data.joana.query = query ? query.replace(/\n/g, ' ') : '';

            data.joana.query = query;
            data.joana.query_type = this.query_type || '';
          }
          if (this.data_action.do === 'create_records') {
            data.joana.input = this.data_action.input;
          }
          if (this.dataEdit && this.dataEdit.id) {
            data.id = this.dataEdit.id;
          }
          resolve(data);
        } else if (!this.validateData() && this.data_action.object === 'generate_file' && this.data_action.generate_file.type === 'csv') {
          const data = {
            type: 'generate_file_csv',
            container_variable: this.data_action.variable_name,
            generate_file_csv: this.data_action.generate_file,
            is_async: this.data_action.is_async,
            is_disable: this.data_action.is_disable,
            is_disable_log: this.data_action.is_disable_log,
          };
          delete data.generate_file_csv.type;
          if (this.dataEdit && this.dataEdit.id) {
            data.id = this.dataEdit.id;
          }
          resolve(data);
        } else if (!this.validateData() && this.data_action.object === 'generate_file' && this.data_action.generate_file.type === 'txt') {
          const data = {
            type: 'generate_file_text',
            container_variable: this.data_action.variable_name,
            generate_file_text: this.data_action.generate_file,
            is_async: this.data_action.is_async,
            is_disable: this.data_action.is_disable,
            is_disable_log: this.data_action.is_disable_log,
          };
          delete data.generate_file_text.type;
          if (this.dataEdit && this.dataEdit.id) data.id = this.dataEdit.id;
          resolve(data);
        } else if (!this.validateData() && this.data_action.object === 'file_transfer_ftp') {
          const data = {
            type: this.data_action.file_transfer_ftp.do,
            is_async: this.data_action.is_async,
            is_disable: this.data_action.is_disable,
            is_disable_log: this.data_action.is_disable_log,
            container_variable: this.data_action.variable_name,
            [this.data_action.file_transfer_ftp.do]: this.data_action.file_transfer_ftp,
          };
          if (data.type === 'ftp_upload' || data.type === 'ftp_read_single_file') {
            data[this.data_action.file_transfer_ftp.do].compress = '';
          }
          delete data[this.data_action.file_transfer_ftp.do].do;
          if (this.dataEdit && this.dataEdit.id) data.id = this.dataEdit.id;
          resolve(data);
        } else if (!this.validateData() && this.data_action.object === 'compress_file') {
          const type = `compress_file_${this.data_action.compress_file.do}`;
          const data = {
            type,
            is_async: this.data_action.is_async,
            is_disable: this.data_action.is_disable,
            is_disable_log: this.data_action.is_disable_log,
            container_variable: this.data_action.variable_name,
            [type]: {
              name: this.data_action.compress_file.name,
              compress_type: this.data_action.compress_file.compress_type,
              password: this.data_action.compress_file.password,
              destination_folder: this.data_action.compress_file.destination_folder,
            },
          };
          if (this.data_action.compress_file.do === 'base64') {
            data[type].data = this.data_action.compress_file.dataBase64;
          } else if (this.data_action.compress_file.do === 'multiple_url') {
            data[type].data = this.data_action.compress_file.dataPublicUrl;
          } else if (this.data_action.compress_file.do === 'company_drive') {
            data[type].data = this.data_action.compress_file.dataCompanyDrive;
          }
          delete data[type].do;
          if (this.dataEdit && this.dataEdit.id) data.id = this.dataEdit.id;
          resolve(data);
        } else {
          reject(null);
        }
      });
    },

    addColumn() {
      this.data_action.column.push({
        name: '',
        value: '',
      });
    },

    deleteColumn(index) {
      this.data_action.column.splice(index, 1);
    },

    objectSelected() {
      this.data_action.table_group = null;
      this.data_action.form = null;
      this.data_action.do = null;

      setTimeout(() => {
        this.$v.data_action.$reset();
      }, 100);
    },

    adjustHtml(str) {
      let normalized = str.replace(/</g, '+\'<');
      normalized = normalized.replace(/>/g, ">'+");
      normalized = normalized.replace(/>\'\+\+\'</g, '><');
      normalized = `''${normalized}''`;
      return normalized;
    },

    deadjustHtml(str) {
      let denormalized = str.replace(/\+\'</g, '<');
      denormalized = denormalized.replace(new RegExp('^[\'][\']'), '');
      denormalized = denormalized.replace(new RegExp('[\'][\']$'), '');
      denormalized = denormalized.replace(/>\'\+/g, '>');
      return denormalized;
    },

    showProperties() {
      if (this.propertiesOpened) {
        this.setPropertiesOpened({
          open: false,
        });

        setTimeout(() => {
          this.blockActive = true;
          this.setPropertiesOpened({
            open: true,
            type: 'action',
            data: this.dataEdit,
            index: this.dataIndex,
            row: this.row,
            dataParent: this.dataParent,
            idBlock: this.id,
          });
        }, 100);
      } else {
        this.blockActive = true;
        this.setPropertiesOpened({
          open: true,
          type: 'action',
          data: this.dataEdit,
          index: this.dataIndex,
          row: this.row,
          dataParent: this.dataParent,
          idBlock: this.id,
        });
      }
    },

    openTabVP() {
      if (this.objectType === 'function') {
        const functionName = this.dataEdit.function.name;
        this.getListFunction(functionName);
      } else if (this.objectType === 'job') {
        const jobName = this.dataEdit.job.name;
        this.getListJob(jobName);
      } else if (this.objectType === 'dedicated_job') {
        const jobName = this.dataEdit.dedicated_job.name;
        this.getListDedicatedJob(jobName);
      }
    },

    setErrorBlock() {
      this.blockError = true;
    },

    clearErrorBlock() {
      this.blockError = false;
    },

    getListGroupDataset() {
      const req = {
        page: 1,
        limit: 1000000,
        sort: { updated_at: -1 },
        filter: null,
        filter_operator: 'and',
      };
      this.getListDataGroup(req).then((res) => {
        if (res.data) {
          this.datasetGroupOptions = res.data;
        }
      });
    },

    openListQuery() {
      const param = {
        page: 1,
        limit: 1000000,
        sort: { updated_at: -1 },
        filter: {
          where_is_and: {
            dataset_id: this.data_action.joana.dataset.id,
          },
        },
        filter_operator: 'and',
      };
      this.listQuery(param).then((res) => {
        if (!res.error) {
          this.listQuerySaved = res.data;
          this.$refs.listSavedQueryModal.show();
        }
      });
    },

    closeModalListSaved() {
      this.$refs.listSavedQueryModal.hide();
    },

    openQuerySelected() {
      // const query = this.dataQuery.trim();
      const query = typeof this.$refs.queryEditor !== 'undefined' ? this.$refs.queryEditor.getData().trim() : '';
      if (query) {
        this.$swal({
          title: 'Replace Query',
          text: 'Are you sure want to replace your existing query with selected saved query?',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.value) {
            this.dataQuery = this.querySelected.query ? `"${this.querySelected.query}"\n\n\n\n\n` : '';
            this.query_type = this.querySelected.query_type || '';
            this.closeModalListSaved();
          }
        });
      } else {
        this.dataQuery = this.querySelected.query ? `"${this.querySelected.query}"\n\n\n\n\n` : '';
        this.query_type = this.querySelected.query_type || '';
        this.closeModalListSaved();
      }
    },

    changeQueryType(type) {
      this.query_type = type;
      this.$refs.queryEditor.changeLanguage(type === 'mongodb' ? 'json' : 'sql');
    },

    openModalCondition(index) {
      const selectedCondition = this.data_action.conditions[index];
      this.selectedIndexCondition = selectedCondition ? index : (this.data_action.conditions.length || 0);
      this.dataItemCondition = selectedCondition || null;

      this.toggleModalCondition(true);
    },

    toggleModalCondition(status) {
      if (status) {
        this.isOpenModalCondition = true;
        setTimeout(() => {
          const element = document.getElementById('idModalCondition');
          if (element) element.classList.add('show');
        }, 200);
      } else {
        const element = document.getElementById('idModalCondition');
        if (element) element.classList.remove('show');

        setTimeout(() => {
          this.selectedIndexCondition = null;
          this.dataItemCondition = null;
          this.isOpenModalCondition = false;
        }, 200);
      }
    },

    submitModalCondition(data) {
      this.setNewFilterCondition(data);
      this.toggleModalCondition(false);
    },

    setNewFilterCondition(data) {
      this.$v.data_action.$reset();
      const { field, operator, value, fromValueBetween, toValueBetween } = data;
      if (this.data_action.conditions.length < 1) {
        this.data_action.conditions.push({
          field,
          operator,
          value: operator === 'between' ? [Number(fromValueBetween), Number(toValueBetween)] : value,
        });
      } else {
        this.data_action.conditions[this.selectedIndexCondition] = {
          field,
          operator,
          value: operator === 'between' ? [Number(fromValueBetween), Number(toValueBetween)] : value,
        };
      }
    },

    toggleModalExample(status) {
      if (status) {
        this.isOpenModalExample = true;
        setTimeout(() => {
          const element = document.getElementById('idModalExample');
          if (element) element.classList.add('show');
        }, 200);
      } else {
        const element = document.getElementById('idModalExample');
        if (element) element.classList.remove('show');

        setTimeout(() => {
          this.isOpenModalExample = false;
        }, 200);
      }
    },

    openModalCompanyDrive(isMultiple, isContentCompressFile) {
      this.multipleSourceFile = isMultiple;
      this.isOpenModalCompanyDrive = true;
      this.isOpenCompDriveFromContentCompressFile = isContentCompressFile || false;
      setTimeout(() => {
        const element = document.getElementById('idModalCompanyDrive');
        if (element) element.classList.add('show');
      }, 200);
    },

    closeModalCompanyDrive() {
      const element = document.getElementById('idModalCompanyDrive');
      if (element) element.classList.remove('show');
      setTimeout(() => {
        this.isOpenModalCompanyDrive = false;
        this.isOpenCompDriveFromContentCompressFile = false;
        this.multipleSourceFile = false;
      }, 200);
    },

    handleCloseModalCompanyDrive(data) {
      if (!data) this.closeModalCompanyDrive();
      else {
        if (this.data_action.object === 'generate_file') {
          this.data_action.generate_file.path = data;
        } else if (this.data_action.object === 'file_transfer_ftp') {
          if (this.data_action.file_transfer_ftp.do === 'ftp_download_single_file') {
            this.data_action.file_transfer_ftp.destination_path = data;
          } else if (this.data_action.file_transfer_ftp.do === 'ftp_upload') {
            this.data_action.file_transfer_ftp.source_file = data;
          }
        } else if (this.data_action.object === 'compress_file') {
          if (this.isOpenCompDriveFromContentCompressFile) {
            this.data_action.compress_file.dataCompanyDrive = data;
          } else {
            this.data_action.compress_file.destination_folder = data;
          }
        }
        this.closeModalCompanyDrive();
      }
    },

    openModalFtp() {
      this.isOpenModalFtp = true;
      setTimeout(() => {
        const element = document.getElementById('idModalFtp');
        if (element) element.classList.add('show');
      }, 200);
    },

    closeModalFtp() {
      const element = document.getElementById('idModalFtp');
      if (element) element.classList.remove('show');
      setTimeout(() => {
        this.isOpenModalFtp = false;
      }, 200);
    },

    handleCloseModalFtp(data) {
      if (!data) this.closeModalFtp();
      else {
        // if (this.data_action.object === 'generate_file') {
        //   this.data_action.generate_file.path = data;
        // } else {
        //   this.data_action.file_transfer_ftp.source_file = data;
        // }
        this.closeModalFtp();
      }
    },
  },
  validations() {
    return {
      data_action: {
        object: {
          required,
        },
        table_group: {
          required: requiredIf(() => this.data_action.object === 'form'),
        },
        form: {
          required: requiredIf(() => this.data_action.object === 'form'),
        },
        do: {
          required: requiredIf(() => this.data_action.object === 'form' || this.data_action.object === 'joana'),
        },
        do_jdc: {
          required: requiredIf(() => this.data_action.object === 'data_connectivity'),
        },
        variable_name: {
          // eslint-disable-next-line arrow-body-style
          required: requiredIf(() => {
            return this.data_action.do === 'create_record' ||
                    this.data_action.do === 'find_record' ||
                    this.data_action.do === 'find_records' ||
                    this.data_action.do === 'update_record' ||
                    this.data_action.do === 'delete_record' ||
                    // this.data_action.object === 'read_file' ||
                    // this.data_action.object === 'generate_spreadsheet_file' ||
                    this.data_action.object === 'send_notification' ||
                    // this.data_action.object === 'transform_file' ||
                    this.data_action.object === 'function' ||
                    this.data_action.object === 'call_webhook' ||
                    this.data_action.object === 'data_connectivity' ||
                    this.data_action.object === 'generate_file' ||
                    this.data_action.object === 'file_transfer_ftp' ||
                    this.data_action.object === 'compress_file';
          }),
        },
        conditions: {
          required: requiredIf(() => this.data_action.do === 'update_record' && this.data_action.object === 'joana'),
          $each: {
            field: {
              // eslint-disable-next-line arrow-body-style
              // required: requiredIf(() => {
              //   return this.data_action.do === 'find_record' ||
              //           this.data_action.do === 'find_records';
              // }),
            },
            operator: {
              // eslint-disable-next-line arrow-body-style
              // required: requiredIf(() => {
              //   return this.data_action.do === 'find_record' ||
              //           this.data_action.do === 'find_records';
              // }),
            },
            value: {
              // eslint-disable-next-line arrow-body-style
              // required: requiredIf(() => {
              //   return this.data_action.do === 'find_record' ||
              //           this.data_action.do === 'find_records';
              // }),
            },
          },
        },
        query: {
          // eslint-disable-next-line arrow-body-style
          required: requiredIf(() => this.data_action.object === 'data_connectivity'),
        },
        connection: {
          required: requiredIf(() => this.data_action.object === 'data_connectivity'),
        },

        method: {
          required: requiredIf(() => this.data_action.object === 'call_webhook'),
        },
        url: {
          required: requiredIf(() => this.data_action.object === 'call_webhook'),
        },
        body: {
          // eslint-disable-next-line arrow-body-style
          // required: requiredIf(() => {
          //   return this.data_action.object === 'call_webhook' ||
          //           this.data_action.object === 'send_notification';
          // }),
        },
        column: {
          // $each: {
          //   name: {
          //     // eslint-disable-next-line arrow-body-style
          //     required: requiredIf(() => {
          //       return this.data_action.object === 'call_webhook' ||
          //               this.data_action.object === 'generate_spreadsheet_file';
          //     }),
          //   },
          //   value: {
          //     // eslint-disable-next-line arrow-body-style
          //     required: requiredIf(() => {
          //       return this.data_action.object === 'call_webhook' ||
          //               this.data_action.object === 'generate_spreadsheet_file';
          //     }),
          //   },
          // },
        },
        content_type: {
          // required: requiredIf(() => this.data_action.object === 'call_webhook'),
        },

        type: {
          // eslint-disable-next-line arrow-body-style
          required: requiredIf(() => {
            return this.data_action.object === 'send_notification';
            // this.data_action.object === 'read_file' ||
            // this.data_action.object === 'generate_spreadsheet_file' ||
            // this.data_action.object === 'transform_file';
          }),
        },
        to_email: {
          required: requiredIf(() => (this.data_action.object === 'send_notification' && this.data_action.type === 'send_email')),
        },
        subject: {
          required: requiredIf(() => (this.data_action.object === 'send_notification' && this.data_action.object === 'send_email')),
        },
        message: {
          required: requiredIf(() => (this.data_action.object === 'send_notification' && this.data_action.type === 'send_email')),
        },
        push_notif_to: {
          required: requiredIf(() => (this.data_action.object === 'send_notification' && this.data_action.type === 'send_notification')),
        },
        push_notif_content: {
          required: requiredIf(() => (this.data_action.object === 'send_notification' && this.data_action.type === 'send_notification')),
        },
        push_notif_heading: {
          required: requiredIf(() => (this.data_action.object === 'send_notification' && this.data_action.type === 'send_notification')),
        },
        variable_name_container: {
          required: requiredIf(() => this.data_action.object === 'transform_file'),
        },
        function_name: {
          required: requiredIf(() => this.data_action.object === 'function'),
        },
        job_name: {
          required: requiredIf(() => this.data_action.object === 'job'),
        },
        dedicated_job_name: {
          required: requiredIf(() => this.data_action.object === 'dedicated_job'),
        },
        input: { },
        sorting: {
          key: {},
          order: {},
        },
        page: {},
        limit: {},
        is_custom_redirect: {},
        script_redirect: {},
        variable_redirect: {
          required: requiredIf(() => (this.data_action.object === 'send_notification' && this.data_action.type === 'send_notification' && this.data_action.is_custom_redirect)),
        },
        joana: {
          group: {
            required: requiredIf(() => this.data_action.object === 'joana'),
          },
          dataset: {
            required: requiredIf(() => this.data_action.object === 'joana'),
          },
        },
        generate_file: {
          type: {
            required: requiredIf(() => this.data_action.object === 'generate_file'),
          },
          extension: {
            required: requiredIf(() => this.data_action.object === 'generate_file'),
          },
          file_name: {
            required: requiredIf(() => this.data_action.object === 'generate_file'),
          },
          data_type: {
            required: requiredIf(() =>
              this.data_action.object === 'generate_file' &&
              this.data_action.generate_file.type === 'csv',
            ),
          },
          header: {
            required: requiredIf(() => this.data_action.object === 'generate_file'),
          },
          data: {
            required: requiredIf(() => this.data_action.object === 'generate_file'),
          },
          delimiter: {
            required: requiredIf(() =>
              this.data_action.object === 'generate_file' &&
              this.data_action.generate_file.type === 'csv',
            ),
          },
          encryption: {
            active: {},
            algorithm: {},
            cipher_mode: {
              required: requiredIf(() =>
                this.data_action.object === 'generate_file' &&
                this.data_action.generate_file.type === 'csv' &&
                this.data_action.generate_file.encryption.active,
              ),
            },
            output_text_format: {
              required: requiredIf(() =>
                this.data_action.object === 'generate_file' &&
                this.data_action.generate_file.type === 'csv' &&
                this.data_action.generate_file.encryption.active,
              ),
            },
            initial_vector: {},
            secret_key: {
              required: requiredIf(() =>
                this.data_action.object === 'generate_file' &&
                this.data_action.generate_file.type === 'csv' &&
                this.data_action.generate_file.encryption.active,
              ),
              minLength: minLength(32),
            },
          },
        },
        file_transfer_ftp: {
          do: {
            required: requiredIf(() => this.data_action.object === 'file_transfer_ftp'),
          },
          third_party_connection: {
            required: requiredIf(() => this.data_action.object === 'file_transfer_ftp'),
          },
          source_file: {
            required: requiredIf(() =>
              this.data_action.object === 'file_transfer_ftp' &&
              (this.data_action.file_transfer_ftp.do === 'ftp_upload' ||
                this.data_action.file_transfer_ftp.do === 'ftp_download_single_file'
              ),
            ),
          },
          source_path: {
            required: requiredIf(() =>
              this.data_action.object === 'file_transfer_ftp' && this.data_action.file_transfer_ftp.do === 'ftp_read_single_file',
            ),
          },
          ftp_source_file_path: {
            required: requiredIf(() =>
              this.data_action.object === 'file_transfer_ftp' &&
              (this.data_action.file_transfer_ftp.do === 'ftp_move_single_file' ||
                this.data_action.file_transfer_ftp.do === 'ftp_delete_single_file'
              ),
            ),
          },
          destination_path: {
            required: requiredIf(() =>
              this.data_action.object === 'file_transfer_ftp' &&
              (this.data_action.file_transfer_ftp.do === 'ftp_upload' ||
                this.data_action.file_transfer_ftp.do === 'ftp_download_single_file'
              ),
            ),
          },
          ftp_destination_folder: {
            required: requiredIf(() =>
              this.data_action.object === 'file_transfer_ftp' && this.data_action.file_transfer_ftp.do === 'ftp_move_single_file',
            ),
          },
          extension: {
            required: requiredIf(() =>
              this.data_action.object === 'file_transfer_ftp' && this.data_action.file_transfer_ftp.do === 'ftp_read_single_file',
            ),
          },
        },
        delimiterSelected: {
          required: requiredIf(() =>
            this.data_action.object === 'generate_file' &&
            this.data_action.generate_file.type === 'csv',
          ),
        },
        compress_file: {
          do: {
            required: requiredIf(() => this.data_action.object === 'compress_file'),
          },
          dataBase64: {
            required: requiredIf(() =>
              this.data_action.object === 'compress_file' &&
              this.data_action.compress_file.do === 'base64',
            ),
          },
          dataPublicUrl: {
            required: requiredIf(() =>
              this.data_action.object === 'compress_file' &&
              this.data_action.compress_file.do === 'multiple_url',
            ),
          },
          dataCompanyDrive: {
            required: requiredIf(() =>
              this.data_action.object === 'compress_file' &&
              this.data_action.compress_file.do === 'company_drive',
            ),
          },
          name: {
            required: requiredIf(() => this.data_action.object === 'compress_file'),
          },
          compress_type: {
            required: requiredIf(() => this.data_action.object === 'compress_file'),
          },
          destination_folder: {
            required: requiredIf(() => this.data_action.object === 'compress_file'),
          },
        },
      },
    };
  },
};
</script>

<style lang="scss">
.company-drive-path {
  position: relative;

  input {
    padding-right: 45px;
  }
  .icon-search {
    position: absolute;
    top: 32px;
    right: 15px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/visual-programming/jVPBlockAction.vue